const people = [
  {
    "web-scraper-order": "1666026991-1546",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩸 Drop of Blood",
    "people-href": "https://emojipedia.org/drop-of-blood/",
    emojiName: "🩸 Drop of Blood",
    description:
      "A red drop of blood. May be used to talk about bleeding, injury, blood donation, or menstruation.",
    emoji: "🩸",
  },
  {
    "web-scraper-order": "1666026994-1549",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💼 Briefcase",
    "people-href": "https://emojipedia.org/briefcase/",
    emojiName: "💼 Briefcase",
    description:
      "A place to store notes and other office materials. Primarily used by older people.",
    emoji: "💼",
  },
  {
    "web-scraper-order": "1666026997-1552",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💍 Ring",
    "people-href": "https://emojipedia.org/ring/",
    emojiName: "💍 Ring",
    description:
      "A ring with displaying a gem stone of some kind on the top, most likely a diamond. This piece of jewellery is often associated with a proposal and subsequent engagement to be married.",
    emoji: "💍",
  },
  {
    "web-scraper-order": "1666026999-1554",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💄 Lipstick",
    "people-href": "https://emojipedia.org/lipstick/",
    emojiName: "💄 Lipstick",
    description:
      "Lipstick shown with the lid removed. Displays in a shade of red on most platforms, except WhatsApp and Twitter which have a more a pinkish color.",
    emoji: "💄",
  },
  {
    "web-scraper-order": "1666027002-1558",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "⛑️ Rescue Worker’s Helmet",
    "people-href": "https://emojipedia.org/rescue-workers-helmet/",
    emojiName: "⛑️ Rescue Worker’s Helmet",
    description:
      "A construction helmet, which is worn by the construction worker emoji in some emoji sets.",
    emoji: "⛑️",
  },
  {
    "web-scraper-order": "1666027005-1561",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🪖 Military Helmet",
    "people-href": "https://emojipedia.org/military-helmet/",
    emojiName: "🪖 Military Helmet",
    description:
      "A round military helmet with a chinstrap. All platforms depict a green helmet, with some designs featuring a green camouflage pattern.",
    emoji: "🪖",
  },
  {
    "web-scraper-order": "1666027007-1563",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧢 Billed Cap",
    "people-href": "https://emojipedia.org/billed-cap/",
    emojiName: "🧢 Billed Cap",
    description:
      "Billed Cap was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧢",
  },
  {
    "web-scraper-order": "1666027010-1566",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎓 Graduation Cap",
    "people-href": "https://emojipedia.org/graduation-cap/",
    emojiName: "🎓 Graduation Cap",
    description:
      "A graduation cap, worn on the head of students graduating from college or university. Known in some locations as a mortar board with tassel.",
    emoji: "🎓",
  },
  {
    "web-scraper-order": "1666027012-1568",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎩 Top Hat",
    "people-href": "https://emojipedia.org/top-hat/",
    emojiName: "🎩 Top Hat",
    description:
      "A top hat, worn in traditional British weddings and other formal occasions. This is also a popular playing piece in the game of Monopoly.",
    emoji: "🎩",
  },
  {
    "web-scraper-order": "1666027014-1570",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👒 Woman’s Hat",
    "people-href": "https://emojipedia.org/womans-hat/",
    emojiName: "👒 Woman’s Hat",
    description: "A hat worn by women for sun protection, or for fashion.",
    emoji: "👒",
  },
  {
    "web-scraper-order": "1666027017-1573",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👑 Crown",
    "people-href": "https://emojipedia.org/crown/",
    emojiName: "👑 Crown",
    description:
      "A gold crown with jewels on the sides. Representative of a King, Queen, or other form of Royalty.",
    emoji: "👑",
  },
  {
    "web-scraper-order": "1666027019-1576",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👢 Woman’s Boot",
    "people-href": "https://emojipedia.org/womans-boot/",
    emojiName: "👢 Woman’s Boot",
    description:
      "A tall boot generally featuring a slight heel, shown in brown or red on most platforms.",
    emoji: "👢",
  },
  {
    "web-scraper-order": "1666027021-1579",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩰 Ballet Shoes",
    "people-href": "https://emojipedia.org/ballet-shoes/",
    emojiName: "🩰 Ballet Shoes",
    description:
      "Shoes worn by ballet dancers for pointe work. Most platforms show a pair of pink shoes resting on their pointes. Sometimes used to represent dancing in general, rather than ballet specifically. Sometimes also used to represent the color pink.",
    emoji: "🩰",
  },
  {
    "web-scraper-order": "1666027024-1582",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👡 Woman’s Sandal",
    "people-href": "https://emojipedia.org/womans-sandal/",
    emojiName: "👡 Woman’s Sandal",
    description:
      "A sandal worn by a woman in summer, spring, or other weather that suits open-toed footwear. Has a heel at the back providing additional height to the wearer.",
    emoji: "👡",
  },
  {
    "web-scraper-order": "1666027027-1585",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👠 High-Heeled Shoe",
    "people-href": "https://emojipedia.org/high-heeled-shoe/",
    emojiName: "👠 High-Heeled Shoe",
    description:
      "A high-heeled shoe, primarily worn by women. Generally found in a context which requires formal dress, such as social occasions, or some work places.",
    emoji: "👠",
  },
  {
    "web-scraper-order": "1666027029-1588",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥿 Flat Shoe",
    "people-href": "https://emojipedia.org/flat-shoe/",
    emojiName: "🥿 Flat Shoe",
    description:
      "A flat shoe, in a style generally worn by women. More practical than a high-heeled shoe.",
    emoji: "🥿",
  },
  {
    "web-scraper-order": "1666027032-1591",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥾 Hiking Boot",
    "people-href": "https://emojipedia.org/hiking-boot/",
    emojiName: "🥾 Hiking Boot",
    description:
      "A style of boot commonly worn on long walks or for hiking. Generally distinct from other footwear-related emojis by the considerable grip on the sole of the shoe.",
    emoji: "🥾",
  },
  {
    "web-scraper-order": "1666027034-1594",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👟 Running Shoe",
    "people-href": "https://emojipedia.org/running-shoe/",
    emojiName: "👟 Running Shoe",
    description:
      "A sneaker – a comfortable shoe used in sports such as tennis or golf, or for fashion purposes.",
    emoji: "👟",
  },
  {
    "web-scraper-order": "1666027037-1597",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👞 Man’s Shoe",
    "people-href": "https://emojipedia.org/mans-shoe/",
    emojiName: "👞 Man’s Shoe",
    description:
      "A shoe worn by a man, to work, dinner, or another occasion that requires footwear. Unlike womens shoes, this shoe is likely to be comfortable.",
    emoji: "👞",
  },
  {
    "web-scraper-order": "1666027040-1600",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩴 Thong Sandal",
    "people-href": "https://emojipedia.org/thong-sandal/",
    emojiName: "🩴 Thong Sandal",
    description:
      "A single flip flop or thong sandal. Often worn to the beach and/or in warm weather. Can be used to talk about sandals, the beach, or warm weather in general.",
    emoji: "🩴",
  },
  {
    "web-scraper-order": "1666027042-1603",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎒 Backpack",
    "people-href": "https://emojipedia.org/backpack/",
    emojiName: "🎒 Backpack",
    description:
      "A school bag Emoji (also called a satchel) used by children attending school to carry books, lunch, and other personal belongings.",
    emoji: "🎒",
  },
  {
    "web-scraper-order": "1666027045-1606",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👝 Clutch Bag",
    "people-href": "https://emojipedia.org/clutch-bag/",
    emojiName: "👝 Clutch Bag",
    description:
      "A small pouch, somewhere between the size of a handbag, and a purse.",
    emoji: "👝",
  },
  {
    "web-scraper-order": "1666027047-1609",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👜 Handbag",
    "people-href": "https://emojipedia.org/handbag/",
    emojiName: "👜 Handbag",
    description:
      "A bag or purse, used to carry personal items, often doubling as a fashion accessory.",
    emoji: "👜",
  },
  {
    "web-scraper-order": "1666027050-1612",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👛 Purse",
    "people-href": "https://emojipedia.org/purse/",
    emojiName: "👛 Purse",
    description:
      "A small pouch with a clasp, generally used to hold coins. Sometimes called a “coin purse.”",
    emoji: "👛",
  },
  {
    "web-scraper-order": "1666027053-1615",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👚 Woman’s Clothes",
    "people-href": "https://emojipedia.org/womans-clothes/",
    emojiName: "👚 Woman’s Clothes",
    description: "A blouse worn by women in a neat-casual setting.",
    emoji: "👚",
  },
  {
    "web-scraper-order": "1666027055-1618",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👙 Bikini",
    "people-href": "https://emojipedia.org/bikini/",
    emojiName: "👙 Bikini",
    description:
      "A two-piece bikini, worn at the beach, pool, or on vacation at a tropical destination.",
    emoji: "👙",
  },
  {
    "web-scraper-order": "1666027059-1621",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩳 Shorts",
    "people-href": "https://emojipedia.org/shorts/",
    emojiName: "🩳 Shorts",
    description:
      "Shorts or swimming trunks. This emoji is shown in different colors and styles across platforms. Most platforms depict this emoji in a casual sporty style.",
    emoji: "🩳",
  },
  {
    "web-scraper-order": "1666027061-1624",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩲 Briefs",
    "people-href": "https://emojipedia.org/briefs/",
    emojiName: "🩲 Briefs",
    description:
      "Underwear or swim briefs. The swimming variety are often called 'Speedos' after the brand. This emoji is shown in different colors and styles across platforms. Some platforms depict this emoji as tighty whities with a visible fly, while others use a less specific design.",
    emoji: "🩲",
  },
  {
    "web-scraper-order": "1666027063-1627",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩱 One-Piece Swimsuit",
    "people-href": "https://emojipedia.org/one-piece-swimsuit/",
    emojiName: "🩱 One-Piece Swimsuit",
    description:
      "A sporty one-piece swimsuit shown in a variety of colors and patterns across different platforms.",
    emoji: "🩱",
  },
  {
    "web-scraper-order": "1666027066-1630",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥻 Sari",
    "people-href": "https://emojipedia.org/sari/",
    emojiName: "🥻 Sari",
    description:
      "A brightly colored sari draped in different ways across platforms. Sometimes used to mean a dress in general.",
    emoji: "🥻",
  },
  {
    "web-scraper-order": "1666027068-1633",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👘 Kimono",
    "people-href": "https://emojipedia.org/kimono/",
    emojiName: "👘 Kimono",
    description:
      "A traditional Japanese robe that can be worn by women or men.",
    emoji: "👘",
  },
  {
    "web-scraper-order": "1666027070-1636",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👗 Dress",
    "people-href": "https://emojipedia.org/dress/",
    emojiName: "👗 Dress",
    description:
      "A pretty dress, suitable for a ball, party or other similar occasion.",
    emoji: "👗",
  },
  {
    "web-scraper-order": "1666027073-1639",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧦 Socks",
    "people-href": "https://emojipedia.org/socks/",
    emojiName: "🧦 Socks",
    description:
      "Socks was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧦",
  },
  {
    "web-scraper-order": "1666027075-1642",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧥 Coat",
    "people-href": "https://emojipedia.org/coat/",
    emojiName: "🧥 Coat",
    description: "A winter jacket, shown in a variety of colors and styles.",
    emoji: "🧥",
  },
  {
    "web-scraper-order": "1666027077-1644",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧤 Gloves",
    "people-href": "https://emojipedia.org/gloves/",
    emojiName: "🧤 Gloves",
    description:
      "Gloves was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧤",
  },
  {
    "web-scraper-order": "1666027080-1647",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧣 Scarf",
    "people-href": "https://emojipedia.org/scarf/",
    emojiName: "🧣 Scarf",
    description:
      "Scarf was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧣",
  },
  {
    "web-scraper-order": "1666027082-1650",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👖 Jeans",
    "people-href": "https://emojipedia.org/jeans/",
    emojiName: "👖 Jeans",
    description:
      "Denim jeans, worn by men or women. A popular form of casual trousers worn by the runner emoji in Apple's emoji artwork",
    emoji: "👖",
  },
  {
    "web-scraper-order": "1666027085-1654",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👕 T-Shirt",
    "people-href": "https://emojipedia.org/t-shirt/",
    emojiName: "👕 T-Shirt",
    description:
      "A plain t-shirt, that can be worn by men or women. Displayed as a blue polo shirt on iOS, a light blue ringer t-shirt on Android, Samsung and Windows, or a standard green tee on other platforms.",
    emoji: "👕",
  },
  {
    "web-scraper-order": "1666027089-1658",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👔 Necktie",
    "people-href": "https://emojipedia.org/necktie/",
    emojiName: "👔 Necktie",
    description:
      "A necktie commonly worn at work or formal occasions, usually shown being worn with a shirt.",
    emoji: "👔",
  },
  {
    "web-scraper-order": "1666027092-1661",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦺 Safety Vest",
    "people-href": "https://emojipedia.org/safety-vest/",
    emojiName: "🦺 Safety Vest",
    description:
      "An orange safety vest with reflective lines across the chest and over the shoulders.",
    emoji: "🦺",
  },
  {
    "web-scraper-order": "1666027095-1664",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥼 Lab Coat",
    "people-href": "https://emojipedia.org/lab-coat/",
    emojiName: "🥼 Lab Coat",
    description: "A white coat worn in a science laboratory.",
    emoji: "🥼",
  },
  {
    "web-scraper-order": "1666027099-1668",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥽 Goggles",
    "people-href": "https://emojipedia.org/goggles/",
    emojiName: "🥽 Goggles",
    description:
      "Clear safety goggles. When this emoji was approved in 2018 it was implied to be safety goggles rather than swimming goggles. A year later 🤿 Diving Mask, which is similar in design but used to represent swimming goggles rather than safety goggles, was approved.",
    emoji: "🥽",
  },
  {
    "web-scraper-order": "1666027102-1672",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕶️ Sunglasses",
    "people-href": "https://emojipedia.org/sunglasses/",
    emojiName: "🕶️ Sunglasses",
    description:
      'Sunglasses that can be worn outside for protection from the sun. Often association with connotations of being "cool", or leisurely in sunny places.',
    emoji: "🕶️",
  },
  {
    "web-scraper-order": "1666027104-1675",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👓 Glasses",
    "people-href": "https://emojipedia.org/glasses/",
    emojiName: "👓 Glasses",
    description:
      "Prescription glasses, shown with a variety of frames, depending on platform.",
    emoji: "👓",
  },
  {
    "web-scraper-order": "1666027106-1678",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧶 Yarn",
    "people-href": "https://emojipedia.org/yarn/",
    emojiName: "🧶 Yarn",
    description:
      "A ball of yarn, as used to knit a scarf. Color varies across platforms, but often depicted in green, blue, or magenta and shown with an end unraveling. Sometimes depicted with a pair of knitting needles stuck in the ball.",
    emoji: "🧶",
  },
  {
    "web-scraper-order": "1666027109-1680",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧵 Thread",
    "people-href": "https://emojipedia.org/thread/",
    emojiName: "🧵 Thread",
    description:
      "A spool of thread, as used for sewing. Thread color varies across platforms, though often depicted in red or blue and on a wooden spool. Sometimes shown with an end unraveling.",
    emoji: "🧵",
  },
  {
    "web-scraper-order": "1666027113-1685",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎃 Jack-O-Lantern",
    "people-href": "https://emojipedia.org/jack-o-lantern/",
    emojiName: "🎃 Jack-O-Lantern",
    description:
      "An orange pumpkin carved into the shape of a face and commonly known as a Jack-o’-lantern. See also Halloween.",
    emoji: "🎃",
  },
  {
    "web-scraper-order": "1666027117-1688",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☂️ Umbrella",
    "people-href": "https://emojipedia.org/umbrella/",
    emojiName: "☂️ Umbrella",
    description:
      "An opened, dry umbrella. Generally depicted with purple fabric and a hooked handle.",
    emoji: "☂️",
  },
  {
    "web-scraper-order": "1666027120-1691",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🌂 Closed Umbrella",
    "people-href": "https://emojipedia.org/closed-umbrella/",
    emojiName: "🌂 Closed Umbrella",
    description:
      "An umbrella that is closed, likely as a result of collapsing it prior to going indoors.",
    emoji: "🌂",
  },
  {
    "web-scraper-order": "1666027122-1694",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧳 Luggage",
    "people-href": "https://emojipedia.org/luggage/",
    emojiName: "🧳 Luggage",
    description:
      "A suitcase or bag, as used for traveling. Most platforms depict gray or blue rolling luggage with an extended handle. Commonly used for various content concerning traveling or taking trips, whether for business or leisure.",
    emoji: "🧳",
  },
  {
    "web-scraper-order": "1666027126-1698",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👣 Footprints",
    "people-href": "https://emojipedia.org/footprints/",
    emojiName: "👣 Footprints",
    description:
      "Two human footsteps,  showing the outline of both feet, including all five toes.",
    emoji: "👣",
  },
  {
    "web-scraper-order": "1666027130-1703",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫂 People Hugging",
    "people-href": "https://emojipedia.org/people-hugging/",
    emojiName: "🫂 People Hugging",
    description:
      "Two people hugging, shown as faceless blue forms on most platforms. Details of each person are not distinct and thus no options are available to customize the gender or skin tone of either individual.",
    emoji: "🫂",
  },
  {
    "web-scraper-order": "1666027134-1707",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👥 Busts in Silhouette",
    "people-href": "https://emojipedia.org/busts-in-silhouette/",
    emojiName: "👥 Busts in Silhouette",
    description:
      "Generic profile of two people. Often used in interface design to represent users.",
    emoji: "👥",
  },
  {
    "web-scraper-order": "1666027137-1710",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👤 Bust in Silhouette",
    "people-href": "https://emojipedia.org/bust-in-silhouette/",
    emojiName: "👤 Bust in Silhouette",
    description:
      "Generic profile of one person. Often used in interface design to represent a user.",
    emoji: "👤",
  },
  {
    "web-scraper-order": "1666027141-1714",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🗣️ Speaking Head",
    "people-href": "https://emojipedia.org/speaking-head/",
    emojiName: "🗣️ Speaking Head",
    description:
      "The silhouette of a person speaking. Faces left-to-right, with lines demonstrating speech being expelled. Sometimes used in the context of shouting or mansplaining.",
    emoji: "🗣️",
  },
  {
    "web-scraper-order": "1666027146-1719",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👧‍👧 Family: Woman, Girl, Girl",
    "people-href": "https://emojipedia.org/family-woman-girl-girl/",
    emojiName: "👩‍👧‍👧 Family: Woman, Girl, Girl",
    description:
      "The Family: Woman, Girl, Girl emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027151-1724",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👧‍👦 Family: Woman, Girl, Boy",
    "people-href": "https://emojipedia.org/family-woman-girl-boy/",
    emojiName: "👩‍👧‍👦 Family: Woman, Girl, Boy",
    description:
      "The Family: Woman, Girl, Boy emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner, 👧 Girl and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027156-1728",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👧 Family: Woman, Girl",
    "people-href": "https://emojipedia.org/family-woman-girl/",
    emojiName: "👩‍👧 Family: Woman, Girl",
    description:
      "The Family: Woman, Girl emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👧",
  },
  {
    "web-scraper-order": "1666027161-1733",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👦‍👦 Family: Woman, Boy, Boy",
    "people-href": "https://emojipedia.org/family-woman-boy-boy/",
    emojiName: "👩‍👦‍👦 Family: Woman, Boy, Boy",
    description:
      "The Family: Woman, Boy, Boy emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027166-1738",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👦 Family: Woman, Boy",
    "people-href": "https://emojipedia.org/family-woman-boy/",
    emojiName: "👩‍👦 Family: Woman, Boy",
    description:
      "The Family: Woman, Boy emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👦",
  },
  {
    "web-scraper-order": "1666027171-1743",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👧‍👧 Family: Man, Girl, Girl",
    "people-href": "https://emojipedia.org/family-man-girl-girl/",
    emojiName: "👨‍👧‍👧 Family: Man, Girl, Girl",
    description:
      "The Family: Man, Girl, Girl emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027176-1747",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👧‍👦 Family: Man, Girl, Boy",
    "people-href": "https://emojipedia.org/family-man-girl-boy/",
    emojiName: "👨‍👧‍👦 Family: Man, Girl, Boy",
    description:
      "The Family: Man, Girl, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner, 👧 Girl and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027187-1754",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👧 Family: Man, Girl",
    "people-href": "https://emojipedia.org/family-man-girl/",
    emojiName: "👨‍👧 Family: Man, Girl",
    description:
      "The Family: Man, Girl emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👧",
  },
  {
    "web-scraper-order": "1666027192-1757",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👦‍👦 Family: Man, Boy, Boy",
    "people-href": "https://emojipedia.org/family-man-boy-boy/",
    emojiName: "👨‍👦‍👦 Family: Man, Boy, Boy",
    description:
      "The Family: Man, Boy, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027196-1762",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👦 Family: Man, Boy",
    "people-href": "https://emojipedia.org/family-man-boy/",
    emojiName: "👨‍👦 Family: Man, Boy",
    description:
      "The Family: Man, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👦",
  },
  {
    "web-scraper-order": "1666027206-1766",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👧‍👧 Family: Woman, Woman, Girl, Girl",
    "people-href": "https://emojipedia.org/family-woman-woman-girl-girl/",
    emojiName: "👩‍👩‍👧‍👧 Family: Woman, Woman, Girl, Girl",
    description: "A family with two mothers, and two daughters.",
    emoji: "👩‍👩‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027213-1773",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👦‍👦 Family: Woman, Woman, Boy, Boy",
    "people-href": "https://emojipedia.org/family-woman-woman-boy-boy/",
    emojiName: "👩‍👩‍👦‍👦 Family: Woman, Woman, Boy, Boy",
    description: "A family with two mothers, and two sons.",
    emoji: "👩‍👩‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027218-1777",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👧‍👦 Family: Woman, Woman, Girl, Boy",
    "people-href": "https://emojipedia.org/family-woman-woman-girl-boy/",
    emojiName: "👩‍👩‍👧‍👦 Family: Woman, Woman, Girl, Boy",
    description: "A family with two mothers, one daughter, and one son.",
    emoji: "👩‍👩‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027224-1783",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👧 Family: Woman, Woman, Girl",
    "people-href": "https://emojipedia.org/family-woman-woman-girl/",
    emojiName: "👩‍👩‍👧 Family: Woman, Woman, Girl",
    description: "A family with two mothers, and one daughter.",
    emoji: "👩‍👩‍👧",
  },
  {
    "web-scraper-order": "1666027230-1788",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👦 Family: Woman, Woman, Boy",
    "people-href": "https://emojipedia.org/family-woman-woman-boy/",
    emojiName: "👩‍👩‍👦 Family: Woman, Woman, Boy",
    description: "A family with two mothers, and one son.",
    emoji: "👩‍👩‍👦",
  },
  {
    "web-scraper-order": "1666027238-1795",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👧‍👧 Family: Man, Man, Girl, Girl",
    "people-href": "https://emojipedia.org/family-man-man-girl-girl/",
    emojiName: "👨‍👨‍👧‍👧 Family: Man, Man, Girl, Girl",
    description: "A family with two fathers, and two daughters.",
    emoji: "👨‍👨‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027245-1801",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👦‍👦 Family: Man, Man, Boy, Boy",
    "people-href": "https://emojipedia.org/family-man-man-boy-boy/",
    emojiName: "👨‍👨‍👦‍👦 Family: Man, Man, Boy, Boy",
    description: "A family with two fathers, and two sons.",
    emoji: "👨‍👨‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027249-1805",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👧‍👦 Family: Man, Man, Girl, Boy",
    "people-href": "https://emojipedia.org/family-man-man-girl-boy/",
    emojiName: "👨‍👨‍👧‍👦 Family: Man, Man, Girl, Boy",
    description: "A family with two fathers, one daughter, and one son.",
    emoji: "👨‍👨‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027255-1811",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👧 Family: Man, Man, Girl",
    "people-href": "https://emojipedia.org/family-man-man-girl/",
    emojiName: "👨‍👨‍👧 Family: Man, Man, Girl",
    description: "A family with two fathers, and one daughter.",
    emoji: "👨‍👨‍👧",
  },
  {
    "web-scraper-order": "1666027262-1819",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👦 Family: Man, Man, Boy",
    "people-href": "https://emojipedia.org/family-man-man-boy/",
    emojiName: "👨‍👨‍👦 Family: Man, Man, Boy",
    description: "A family with two fathers, and one son.",
    emoji: "👨‍👨‍👦",
  },
  {
    "web-scraper-order": "1666027270-1823",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👧‍👧 Family: Man, Woman, Girl, Girl",
    "people-href": "https://emojipedia.org/family-man-woman-girl-girl/",
    emojiName: "👨‍👩‍👧‍👧 Family: Man, Woman, Girl, Girl",
    description: "A family with a father, mother, and two daughters.",
    emoji: "👨‍👩‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027277-1829",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👦‍👦 Family: Man, Woman, Boy, Boy",
    "people-href": "https://emojipedia.org/family-man-woman-boy-boy/",
    emojiName: "👨‍👩‍👦‍👦 Family: Man, Woman, Boy, Boy",
    description: "A family with a father, mother, and two sons.",
    emoji: "👨‍👩‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027284-1834",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👧‍👦 Family: Man, Woman, Girl, Boy",
    "people-href": "https://emojipedia.org/family-man-woman-girl-boy/",
    emojiName: "👨‍👩‍👧‍👦 Family: Man, Woman, Girl, Boy",
    description: "A family with a father, mother, daughter, and son.",
    emoji: "👨‍👩‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027291-1839",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👧 Family: Man, Woman, Girl",
    "people-href": "https://emojipedia.org/family-man-woman-girl/",
    emojiName: "👨‍👩‍👧 Family: Man, Woman, Girl",
    description: "A family with a father, mother, and one daughter.",
    emoji: "👨‍👩‍👧",
  },
  {
    "web-scraper-order": "1666027297-1843",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👦 Family: Man, Woman, Boy",
    "people-href": "https://emojipedia.org/family-man-woman-boy/",
    emojiName: "👨‍👩‍👦 Family: Man, Woman, Boy",
    description:
      "The Family: Man, Woman, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner, 👩 Woman and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👩‍👦",
  },
  {
    "web-scraper-order": "1666027303-1847",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👪 Family",
    "people-href": "https://emojipedia.org/family/",
    emojiName: "👪 Family",
    description:
      "A family unit shown with two adults and one child. Previously displayed with the same design as 👨‍👩‍👦 Family: Man, Woman, Boy on most platforms, but now has its own gender inclusive appearance.",
    emoji: "👪",
  },
  {
    "web-scraper-order": "1666027310-1853",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍👩 Couple with Heart: Woman, Woman",
    "people-href": "https://emojipedia.org/couple-with-heart-woman-woman/",
    emojiName: "👩‍❤️‍👩 Couple with Heart: Woman, Woman",
    description:
      "Two women standing next to each other, smiling, with a love heart floating in the air between them.",
    emoji: "👩‍❤️‍👩",
  },
  {
    "web-scraper-order": "1666027315-1857",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍❤️‍👨 Couple with Heart: Man, Man",
    "people-href": "https://emojipedia.org/couple-with-heart-man-man/",
    emojiName: "👨‍❤️‍👨 Couple with Heart: Man, Man",
    description:
      "Two men standing next to each other, smiling, with a love heart floating in the air between them.",
    emoji: "👨‍❤️‍👨",
  },
  {
    "web-scraper-order": "1666027320-1861",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍👨 Couple with Heart: Woman, Man",
    "people-href": "https://emojipedia.org/couple-with-heart-woman-man/",
    emojiName: "👩‍❤️‍👨 Couple with Heart: Woman, Man",
    description:
      "A woman and a man standing next to each other, smiling, with a love heart floating in the air between them.",
    emoji: "👩‍❤️‍👨",
  },
  {
    "web-scraper-order": "1666027325-1865",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💑 Couple with Heart",
    "people-href": "https://emojipedia.org/couple-with-heart/",
    emojiName: "💑 Couple with Heart",
    description:
      "A couple standing next to each other, smiling, with a love heart floating in the air between them. No gender is specified for the two people, and as such this may be used to represent the concept of a couple broadly, and/or as a means of showing two non-binary people.",
    emoji: "💑",
  },
  {
    "web-scraper-order": "1666027331-1870",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍💋‍👩 Kiss: Woman, Woman",
    "people-href": "https://emojipedia.org/kiss-woman-woman/",
    emojiName: "👩‍❤️‍💋‍👩 Kiss: Woman, Woman",
    description:
      "Two women displayed kissing, or gesturing a kiss toward each other. At small sizes this may be difficult to discern from two men kissing.",
    emoji: "👩‍❤️‍💋‍👩",
  },
  {
    "web-scraper-order": "1666027333-1872",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍❤️‍💋‍👨 Kiss: Man, Man",
    "people-href": "https://emojipedia.org/kiss-man-man/",
    emojiName: "👨‍❤️‍💋‍👨 Kiss: Man, Man",
    description:
      "Two men displayed kissing, or gesturing a kiss toward each other. At small sizes this may be difficult to discern from the two women kissing.",
    emoji: "👨‍❤️‍💋‍👨",
  },
  {
    "web-scraper-order": "1666027337-1875",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍💋‍👨 Kiss: Woman, Man",
    "people-href": "https://emojipedia.org/kiss-woman-man/",
    emojiName: "👩‍❤️‍💋‍👨 Kiss: Woman, Man",
    description:
      "The Kiss: Woman, Man emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner, ❤️ Red Heart, 💋 Kiss Mark and 👨 Man.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍❤️‍💋‍👨",
  },
  {
    "web-scraper-order": "1666027342-1879",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💏 Kiss",
    "people-href": "https://emojipedia.org/kiss/",
    emojiName: "💏 Kiss",
    description:
      "A kissing gesture, shown with a pink love heart floating in the air between two people. No gender is specified for the two people, and as such this may be used to represent the concept of a couple broadly, and/or as a means of showing two non-binary people.",
    emoji: "💏",
  },
  {
    "web-scraper-order": "1666027346-1882",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👬 Men Holding Hands",
    "people-href": "https://emojipedia.org/men-holding-hands/",
    emojiName: "👬 Men Holding Hands",
    description:
      "Two men holding hands, most likely due to being in a relationship.",
    emoji: "👬",
  },
  {
    "web-scraper-order": "1666027350-1885",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👫 Woman and Man Holding Hands",
    "people-href": "https://emojipedia.org/woman-and-man-holding-hands/",
    emojiName: "👫 Woman and Man Holding Hands",
    description:
      "A woman and man holding hands, most likely due to being in a relationship.",
    emoji: "👫",
  },
  {
    "web-scraper-order": "1666027354-1889",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👭 Women Holding Hands",
    "people-href": "https://emojipedia.org/women-holding-hands/",
    emojiName: "👭 Women Holding Hands",
    description:
      "Two women holding hands, most likely due to being in a relationship.",
    emoji: "👭",
  },
  {
    "web-scraper-order": "1666027357-1892",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🤝‍🧑 People Holding Hands",
    "people-href": "https://emojipedia.org/people-holding-hands/",
    emojiName: "🧑‍🤝‍🧑 People Holding Hands",
    description:
      "Two people holding hands, most likely due to being in a relationship.",
    emoji: "🧑‍🤝‍🧑",
  },
  {
    "web-scraper-order": "1666027361-1895",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧘 Person in Lotus Position",
    "people-href": "https://emojipedia.org/person-in-lotus-position/",
    emojiName: "🧘 Person in Lotus Position",
    description:
      "Person in Lotus Position was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧘",
  },
  {
    "web-scraper-order": "1666027365-1899",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧖‍♀️ Woman in Steamy Room",
    "people-href": "https://emojipedia.org/woman-in-steamy-room/",
    emojiName: "🧖‍♀️ Woman in Steamy Room",
    description:
      "The Woman in Steamy Room emoji is a ZWJ sequence combining 🧖 Person in Steamy Room, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧖‍♀️",
  },
  {
    "web-scraper-order": "1666027371-1903",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧖‍♂️ Man in Steamy Room",
    "people-href": "https://emojipedia.org/man-in-steamy-room/",
    emojiName: "🧖‍♂️ Man in Steamy Room",
    description:
      "The Man in Steamy Room emoji is a ZWJ sequence combining 🧖 Person in Steamy Room, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧖‍♂️",
  },
  {
    "web-scraper-order": "1666027374-1906",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧖 Person in Steamy Room",
    "people-href": "https://emojipedia.org/person-in-steamy-room/",
    emojiName: "🧖 Person in Steamy Room",
    description:
      "A person in a sauna, usually with a towel or robe and sometimes holding a ladle for pouring water on hot stones to create the steamy environment.",
    emoji: "🧖",
  },
  {
    "web-scraper-order": "1666027377-1909",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👯‍♀️ Women with Bunny Ears",
    "people-href": "https://emojipedia.org/women-with-bunny-ears/",
    emojiName: "👯‍♀️ Women with Bunny Ears",
    description: "A female version of the 👯 People With Bunny Ears emoji.",
    emoji: "👯‍♀️",
  },
  {
    "web-scraper-order": "1666027380-1911",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👯‍♂️ Men with Bunny Ears",
    "people-href": "https://emojipedia.org/men-with-bunny-ears/",
    emojiName: "👯‍♂️ Men with Bunny Ears",
    description: "The male version of the 👯 Woman With Bunny Ears emoji.",
    emoji: "👯‍♂️",
  },
  {
    "web-scraper-order": "1666027384-1915",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👯 People with Bunny Ears",
    "people-href": "https://emojipedia.org/people-with-bunny-ears/",
    emojiName: "👯 People with Bunny Ears",
    description:
      "An iteration of the Playboy Bunny known in Japan as a Bunny Girl. Usually depicted as an attractive woman  wearing bunny ears; a bunny girl can also be seen in anime as a hybrid human/animal known as Kemonomimi.",
    emoji: "👯",
  },
  {
    "web-scraper-order": "1666027386-1918",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕴️ Person in Suit Levitating",
    "people-href": "https://emojipedia.org/person-in-suit-levitating/",
    emojiName: "🕴️ Person in Suit Levitating",
    description:
      "A person wearing a suit, hovering above the ground with a shadow displayed beneath them. Generally shown wearing a fedora or similar style of hat.",
    emoji: "🕴️",
  },
  {
    "web-scraper-order": "1666027389-1921",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕺 Man Dancing",
    "people-href": "https://emojipedia.org/man-dancing/",
    emojiName: "🕺 Man Dancing",
    description:
      "A man dancing, added as a gender pair for the 💃 Woman Dancing. Shown on most platforms in a 70s-era suit, and one hand in the air in a disco-dancing style.",
    emoji: "🕺",
  },
  {
    "web-scraper-order": "1666027393-1926",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💃 Woman Dancing",
    "people-href": "https://emojipedia.org/woman-dancing/",
    emojiName: "💃 Woman Dancing",
    description:
      'A person dancing, most commonly displayed as woman with one arm raised wearing a red dress, while dancing the salsa or flamenco. Often used to represent a sense of fun or as a positive affirmation, e.g. "great! 💃"',
    emoji: "💃",
  },
  {
    "web-scraper-order": "1666027396-1929",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🏃‍♀️ Woman Running",
    "people-href": "https://emojipedia.org/woman-running/",
    emojiName: "🏃‍♀️ Woman Running",
    description: "The female version of the 🏃 Runner emoji.",
    emoji: "🏃‍♀️",
  },
  {
    "web-scraper-order": "1666027399-1932",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🏃‍♂️ Man Running",
    "people-href": "https://emojipedia.org/man-running/",
    emojiName: "🏃‍♂️ Man Running",
    description:
      "The male version of the 🏃 Runner emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🏃‍♂️",
  },
  {
    "web-scraper-order": "1666027402-1935",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🏃 Person Running",
    "people-href": "https://emojipedia.org/person-running/",
    emojiName: "🏃 Person Running",
    description:
      "A person running, with a large stride and arms outstretched. May be wearing a running shirt.",
    emoji: "🏃",
  },
  {
    "web-scraper-order": "1666027405-1938",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦽 Woman in Manual Wheelchair",
    "people-href": "https://emojipedia.org/woman-in-manual-wheelchair/",
    emojiName: "👩‍🦽 Woman in Manual Wheelchair",
    description:
      "The Woman in Manual Wheelchair emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🦽 Manual Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🦽",
  },
  {
    "web-scraper-order": "1666027409-1943",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦽 Man in Manual Wheelchair",
    "people-href": "https://emojipedia.org/man-in-manual-wheelchair/",
    emojiName: "👨‍🦽 Man in Manual Wheelchair",
    description:
      "The Man in Manual Wheelchair emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🦽 Manual Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🦽",
  },
  {
    "web-scraper-order": "1666027413-1946",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦽 Person in Manual Wheelchair",
    "people-href": "https://emojipedia.org/person-in-manual-wheelchair/",
    emojiName: "🧑‍🦽 Person in Manual Wheelchair",
    description:
      "The Person in Manual Wheelchair emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🦽 Manual Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🦽",
  },
  {
    "web-scraper-order": "1666027417-1950",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦼 Woman in Motorized Wheelchair",
    "people-href": "https://emojipedia.org/woman-in-motorized-wheelchair/",
    emojiName: "👩‍🦼 Woman in Motorized Wheelchair",
    description:
      "The Woman in Motorized Wheelchair emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🦼 Motorized Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🦼",
  },
  {
    "web-scraper-order": "1666027421-1953",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦼 Man in Motorized Wheelchair",
    "people-href": "https://emojipedia.org/man-in-motorized-wheelchair/",
    emojiName: "👨‍🦼 Man in Motorized Wheelchair",
    description:
      "The Man in Motorized Wheelchair emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🦼 Motorized Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🦼",
  },
  {
    "web-scraper-order": "1666027426-1957",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦼 Person in Motorized Wheelchair",
    "people-href": "https://emojipedia.org/person-in-motorized-wheelchair/",
    emojiName: "🧑‍🦼 Person in Motorized Wheelchair",
    description:
      "The Person in Motorized Wheelchair emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🦼 Motorized Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🦼",
  },
  {
    "web-scraper-order": "1666027428-1960",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦯 Woman with White Cane",
    "people-href": "https://emojipedia.org/woman-with-white-cane/",
    emojiName: "👩‍🦯 Woman with White Cane",
    description:
      "The Woman with White Cane emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🦯 White Cane.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🦯",
  },
  {
    "web-scraper-order": "1666027431-1962",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦯 Man with White Cane",
    "people-href": "https://emojipedia.org/man-with-white-cane/",
    emojiName: "👨‍🦯 Man with White Cane",
    description:
      "The Man with White Cane emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🦯 White Cane.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🦯",
  },
  {
    "web-scraper-order": "1666027433-1964",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦯 Person with White Cane",
    "people-href": "https://emojipedia.org/person-with-white-cane/",
    emojiName: "🧑‍🦯 Person with White Cane",
    description:
      "The Person with White Cane emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🦯 White Cane.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🦯",
  },
  {
    "web-scraper-order": "1666027436-1967",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧎‍♀️ Woman Kneeling",
    "people-href": "https://emojipedia.org/woman-kneeling/",
    emojiName: "🧎‍♀️ Woman Kneeling",
    description:
      "The Woman Kneeling emoji is a ZWJ sequence combining 🧎 Person Kneeling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧎‍♀️",
  },
  {
    "web-scraper-order": "1666027438-1969",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧎‍♂️ Man Kneeling",
    "people-href": "https://emojipedia.org/man-kneeling/",
    emojiName: "🧎‍♂️ Man Kneeling",
    description:
      "The Man Kneeling emoji is a ZWJ sequence combining 🧎 Person Kneeling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧎‍♂️",
  },
  {
    "web-scraper-order": "1666027441-1971",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧎 Person Kneeling",
    "people-href": "https://emojipedia.org/person-kneeling/",
    emojiName: "🧎 Person Kneeling",
    description:
      "A person kneeling on both knees. May be used to represent someone in prayer, or a person resting on the floor.",
    emoji: "🧎",
  },
  {
    "web-scraper-order": "1666027444-1973",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧍‍♀️ Woman Standing",
    "people-href": "https://emojipedia.org/woman-standing/",
    emojiName: "🧍‍♀️ Woman Standing",
    description:
      "A person standing upright. Commonly used to convey awkwardness, particularly on TikTok.",
    emoji: "🧍‍♀️",
  },
  {
    "web-scraper-order": "1666027446-1975",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧍‍♂️ Man Standing",
    "people-href": "https://emojipedia.org/man-standing/",
    emojiName: "🧍‍♂️ Man Standing",
    description:
      "A man standing upright. Commonly used to convey awkwardness, particularly on TikTok.",
    emoji: "🧍‍♂️",
  },
  {
    "web-scraper-order": "1666027448-1977",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧍 Person Standing",
    "people-href": "https://emojipedia.org/person-standing/",
    emojiName: "🧍 Person Standing",
    description:
      "A person standing upright. Commonly used to convey awkwardness, particularly on TikTok.",
    emoji: "🧍",
  },
  {
    "web-scraper-order": "1666027451-1978",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🚶‍♀️ Woman Walking",
    "people-href": "https://emojipedia.org/woman-walking/",
    emojiName: "🚶‍♀️ Woman Walking",
    description: "The female version of the 🚶 Pedestrian emoji.",
    emoji: "🚶‍♀️",
  },
  {
    "web-scraper-order": "1666027453-1980",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🚶‍♂️ Man Walking",
    "people-href": "https://emojipedia.org/man-walking/",
    emojiName: "🚶‍♂️ Man Walking",
    description:
      "The male version of the 🚶 Pedestrian emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🚶‍♂️",
  },
  {
    "web-scraper-order": "1666027455-1981",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🚶 Person Walking",
    "people-href": "https://emojipedia.org/person-walking/",
    emojiName: "🚶 Person Walking",
    description:
      "A person going for a walk. Taking a slow-medium pace, this person would be a runner if they picked up their speed.",
    emoji: "🚶",
  },
  {
    "web-scraper-order": "1666027460-1983",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💇‍♀️ Woman Getting Haircut",
    "people-href": "https://emojipedia.org/woman-getting-haircut/",
    emojiName: "💇‍♀️ Woman Getting Haircut",
    description:
      "The female version of the 💇 Haircut emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "💇‍♀️",
  },
  {
    "web-scraper-order": "1666027464-1985",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💇‍♂️ Man Getting Haircut",
    "people-href": "https://emojipedia.org/man-getting-haircut/",
    emojiName: "💇‍♂️ Man Getting Haircut",
    description:
      "The Man Getting Haircut emoji is a ZWJ sequence combining 💇 Person Getting Haircut, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "💇‍♂️",
  },
  {
    "web-scraper-order": "1666027468-1987",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💇 Person Getting Haircut",
    "people-href": "https://emojipedia.org/person-getting-haircut/",
    emojiName: "💇 Person Getting Haircut",
    description:
      "A person in the process of getting their hair cut. This emoji is intended to be gender-neutral, but is commonly shown as a girl or woman smiling, with scissors shown open next to the hair on her head.",
    emoji: "💇",
  },
  {
    "web-scraper-order": "1666027472-1989",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💆‍♀️ Woman Getting Massage",
    "people-href": "https://emojipedia.org/woman-getting-massage/",
    emojiName: "💆‍♀️ Woman Getting Massage",
    description:
      "The Woman Getting Massage emoji is a ZWJ sequence combining 💆 Person Getting Massage, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "💆‍♀️",
  },
  {
    "web-scraper-order": "1666027477-1991",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💆‍♂️ Man Getting Massage",
    "people-href": "https://emojipedia.org/man-getting-massage/",
    emojiName: "💆‍♂️ Man Getting Massage",
    description: "The male version of the 💆 Face Massage emoji.",
    emoji: "💆‍♂️",
  },
  {
    "web-scraper-order": "1666027480-1994",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💆 Person Getting Massage",
    "people-href": "https://emojipedia.org/person-getting-massage/",
    emojiName: "💆 Person Getting Massage",
    description: "A person getting his or her face massaged.",
    emoji: "💆",
  },
  {
    "web-scraper-order": "1666027482-1995",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧌 Troll",
    "people-href": "https://emojipedia.org/troll/",
    emojiName: "🧌 Troll",
    description: "A green troll holding a club.",
    emoji: "🧌",
  },
  {
    "web-scraper-order": "1666027487-1998",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧟‍♀️ Woman Zombie",
    "people-href": "https://emojipedia.org/woman-zombie/",
    emojiName: "🧟‍♀️ Woman Zombie",
    description:
      "The Woman Zombie emoji is a ZWJ sequence combining 🧟 Zombie, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧟‍♀️",
  },
  {
    "web-scraper-order": "1666027492-2000",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧟‍♂️ Man Zombie",
    "people-href": "https://emojipedia.org/man-zombie/",
    emojiName: "🧟‍♂️ Man Zombie",
    description:
      "The Man Zombie emoji is a ZWJ sequence combining 🧟 Zombie, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧟‍♂️",
  },
  {
    "web-scraper-order": "1666027497-2002",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧟 Zombie",
    "people-href": "https://emojipedia.org/zombie/",
    emojiName: "🧟 Zombie",
    description:
      "A reanimated human, often found in works of horror fiction. May have a female or male appearance.",
    emoji: "🧟",
  },
  {
    "web-scraper-order": "1666027501-2003",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧞‍♀️ Woman Genie",
    "people-href": "https://emojipedia.org/woman-genie/",
    emojiName: "🧞‍♀️ Woman Genie",
    description:
      "The Woman Genie emoji is a ZWJ sequence combining 🧞 Genie, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧞‍♀️",
  },
  {
    "web-scraper-order": "1666027506-2004",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧞‍♂️ Man Genie",
    "people-href": "https://emojipedia.org/man-genie/",
    emojiName: "🧞‍♂️ Man Genie",
    description:
      "The Man Genie emoji is a ZWJ sequence combining 🧞 Genie, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧞‍♂️",
  },
  {
    "web-scraper-order": "1666027510-2005",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧞 Genie",
    "people-href": "https://emojipedia.org/genie/",
    emojiName: "🧞 Genie",
    description:
      "A supernatural being, which is generally shown to be imprisoned within a bottle or lamp. May be capable of granting wishes when summoned. Variations exist for a female genie or male genie.",
    emoji: "🧞",
  },
  {
    "web-scraper-order": "1666027514-2006",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧝‍♀️ Woman Elf",
    "people-href": "https://emojipedia.org/woman-elf/",
    emojiName: "🧝‍♀️ Woman Elf",
    description:
      "The Woman Elf emoji is a ZWJ sequence combining 🧝 Elf, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧝‍♀️",
  },
  {
    "web-scraper-order": "1666027518-2007",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧝‍♂️ Man Elf",
    "people-href": "https://emojipedia.org/man-elf/",
    emojiName: "🧝‍♂️ Man Elf",
    description:
      "The Man Elf emoji is a ZWJ sequence combining 🧝 Elf, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧝‍♂️",
  },
  {
    "web-scraper-order": "1666027523-2008",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧝 Elf",
    "people-href": "https://emojipedia.org/elf/",
    emojiName: "🧝 Elf",
    description:
      "Creatures with pointed ears and human-like faces. Female and male elves are available.",
    emoji: "🧝",
  },
  {
    "web-scraper-order": "1666027526-2009",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧜‍♀️ Mermaid",
    "people-href": "https://emojipedia.org/mermaid/",
    emojiName: "🧜‍♀️ Mermaid",
    description:
      "The Mermaid emoji is a ZWJ sequence combining 🧜 Merperson, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧜‍♀️",
  },
  {
    "web-scraper-order": "1666027531-2010",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧜‍♂️ Merman",
    "people-href": "https://emojipedia.org/merman/",
    emojiName: "🧜‍♂️ Merman",
    description:
      "The Merman emoji is a ZWJ sequence combining 🧜 Merperson, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧜‍♂️",
  },
  {
    "web-scraper-order": "1666027535-2011",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧜 Merperson",
    "people-href": "https://emojipedia.org/merperson/",
    emojiName: "🧜 Merperson",
    description:
      "A merperson who may be referred to as merfolk or merpeople in plural. May be used for the display of a mermaid, mergirl, merwoman, or merman.",
    emoji: "🧜",
  },
  {
    "web-scraper-order": "1666027540-2012",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧛‍♀️ Woman Vampire",
    "people-href": "https://emojipedia.org/woman-vampire/",
    emojiName: "🧛‍♀️ Woman Vampire",
    description:
      "The Woman Vampire emoji is a ZWJ sequence combining 🧛 Vampire, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧛‍♀️",
  },
  {
    "web-scraper-order": "1666027544-2013",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧛‍♂️ Man Vampire",
    "people-href": "https://emojipedia.org/man-vampire/",
    emojiName: "🧛‍♂️ Man Vampire",
    description:
      "The Man Vampire emoji is a ZWJ sequence combining 🧛 Vampire, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧛‍♂️",
  },
  {
    "web-scraper-order": "1666027548-2014",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧛 Vampire",
    "people-href": "https://emojipedia.org/vampire/",
    emojiName: "🧛 Vampire",
    description:
      "A vampire shown wearing a dark cape, and with pointed fangs. This emoji supports skin tones, and variations that are female or male.",
    emoji: "🧛",
  },
  {
    "web-scraper-order": "1666027551-2015",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧚‍♀️ Woman Fairy",
    "people-href": "https://emojipedia.org/woman-fairy/",
    emojiName: "🧚‍♀️ Woman Fairy",
    description:
      "The Woman Fairy emoji is a ZWJ sequence combining 🧚 Fairy, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧚‍♀️",
  },
  {
    "web-scraper-order": "1666027553-2016",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧚‍♂️ Man Fairy",
    "people-href": "https://emojipedia.org/man-fairy/",
    emojiName: "🧚‍♂️ Man Fairy",
    description:
      "The Man Fairy emoji is a ZWJ sequence combining 🧚 Fairy, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧚‍♂️",
  },
  {
    "web-scraper-order": "1666027556-2017",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧚 Fairy",
    "people-href": "https://emojipedia.org/fairy/",
    emojiName: "🧚 Fairy",
    description:
      "A magical humanoid creature found in myths and fantasy stories. Generally depicted as being diminutive in size and having insect-inspired wings.",
    emoji: "🧚",
  },
  {
    "web-scraper-order": "1666027560-2018",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧙‍♀️ Woman Mage",
    "people-href": "https://emojipedia.org/woman-mage/",
    emojiName: "🧙‍♀️ Woman Mage",
    description:
      "The Woman Mage emoji is a ZWJ sequence combining 🧙 Mage, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧙‍♀️",
  },
  {
    "web-scraper-order": "1666027565-2019",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧙‍♂️ Man Mage",
    "people-href": "https://emojipedia.org/man-mage/",
    emojiName: "🧙‍♂️ Man Mage",
    description:
      "The Man Mage emoji is a ZWJ sequence combining 🧙 Mage, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧙‍♂️",
  },
  {
    "web-scraper-order": "1666027570-2020",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧙 Mage",
    "people-href": "https://emojipedia.org/mage/",
    emojiName: "🧙 Mage",
    description:
      "Mage was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧙",
  },
  {
    "web-scraper-order": "1666027574-2021",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦹‍♀️ Woman Supervillain",
    "people-href": "https://emojipedia.org/woman-supervillain/",
    emojiName: "🦹‍♀️ Woman Supervillain",
    description:
      "The Woman Supervillain emoji is a ZWJ sequence combining 🦹 Supervillain, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦹‍♀️",
  },
  {
    "web-scraper-order": "1666027578-2022",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦹‍♂️ Man Supervillain",
    "people-href": "https://emojipedia.org/man-supervillain/",
    emojiName: "🦹‍♂️ Man Supervillain",
    description:
      "The Man Supervillain emoji is a ZWJ sequence combining 🦹 Supervillain, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦹‍♂️",
  },
  {
    "web-scraper-order": "1666027584-2023",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦹 Supervillain",
    "people-href": "https://emojipedia.org/supervillain/",
    emojiName: "🦹 Supervillain",
    description:
      "A villain which may be displayed as a man,woman or gender-neutral / gender-inclusive depending on the platform. This base emoji does not specify a gender, but is used to create the emojis for Man Supervillain and Woman Supervillain.",
    emoji: "🦹",
  },
  {
    "web-scraper-order": "1666027589-2024",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦸‍♀️ Woman Superhero",
    "people-href": "https://emojipedia.org/woman-superhero/",
    emojiName: "🦸‍♀️ Woman Superhero",
    description:
      "The Woman Superhero emoji is a ZWJ sequence combining 🦸 Superhero, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦸‍♀️",
  },
  {
    "web-scraper-order": "1666027593-2025",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦸‍♂️ Man Superhero",
    "people-href": "https://emojipedia.org/man-superhero/",
    emojiName: "🦸‍♂️ Man Superhero",
    description:
      "The Man Superhero emoji is a ZWJ sequence combining 🦸 Superhero, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦸‍♂️",
  },
  {
    "web-scraper-order": "1666027598-2026",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦸 Superhero",
    "people-href": "https://emojipedia.org/superhero/",
    emojiName: "🦸 Superhero",
    description:
      "A hero which may be displayed as a man,woman or gender-neutral / gender-inclusive depending on the platform. This base emoji does not specify a gender, but is used to create the emojis for Man Superhero and Woman Superhero.",
    emoji: "🦸",
  },
  {
    "web-scraper-order": "1666027604-2027",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎄 Mx Claus",
    "people-href": "https://emojipedia.org/mx-claus/",
    emojiName: "🧑‍🎄 Mx Claus",
    description:
      'A person, generally depicted as being older with gray hair, wearing a red Christmas (aka "Santa") hat. Does not represent any specific character in folklore. Mx Claus provides a gender inclusive alternative to 🎅 Santa Claus or 🤶 Mrs. Claus.',
    emoji: "🧑‍🎄",
  },
  {
    "web-scraper-order": "1666027608-2028",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤶 Mrs. Claus",
    "people-href": "https://emojipedia.org/mrs-claus/",
    emojiName: "🤶 Mrs. Claus",
    description:
      "Mother Christmas, more commonly known as Mrs. Claus, is the wife of Santa Claus. Displayed as an older woman with glasses and a festive red and white bonnet. See also: Christmas emoji list.",
    emoji: "🤶",
  },
  {
    "web-scraper-order": "1666027614-2029",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎅 Santa Claus",
    "people-href": "https://emojipedia.org/santa-claus/",
    emojiName: "🎅 Santa Claus",
    description:
      "Santa Claus, sometimes referred to as Father Christmas, brings joy to children at Christmas time. Displayed with a beard and red festive hat.",
    emoji: "🎅",
  },
  {
    "web-scraper-order": "1666027619-2030",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👼 Baby Angel",
    "people-href": "https://emojipedia.org/baby-angel/",
    emojiName: "👼 Baby Angel",
    description:
      "A baby with a halo and wings. Can represent a sweet baby, a biblical cherub, a mythological cupid, a decorative putto, or an angel as a supernatural being in general. This emoji can be used earnestly or in a tongue-in-cheek way to talk about goodness or innocence.",
    emoji: "👼",
  },
  {
    "web-scraper-order": "1666027624-2031",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🍼 Person Feeding Baby",
    "people-href": "https://emojipedia.org/person-feeding-baby/",
    emojiName: "🧑‍🍼 Person Feeding Baby",
    description:
      "A person feeding a baby with a bottle, sometimes looking down to the infant and smiling.",
    emoji: "🧑‍🍼",
  },
  {
    "web-scraper-order": "1666027628-2032",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🍼 Man Feeding Baby",
    "people-href": "https://emojipedia.org/man-feeding-baby/",
    emojiName: "👨‍🍼 Man Feeding Baby",
    description:
      "A man feeding a baby with a bottle, sometimes looking down to the infant and smiling.",
    emoji: "👨‍🍼",
  },
  {
    "web-scraper-order": "1666027633-2033",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🍼 Woman Feeding Baby",
    "people-href": "https://emojipedia.org/woman-feeding-baby/",
    emojiName: "👩‍🍼 Woman Feeding Baby",
    description:
      "A woman feeding a baby with a bottle, sometimes looking down to the infant and smiling.",
    emoji: "👩‍🍼",
  },
  {
    "web-scraper-order": "1666027637-2034",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤱 Breast-Feeding",
    "people-href": "https://emojipedia.org/breast-feeding/",
    emojiName: "🤱 Breast-Feeding",
    description:
      "A woman shown breastfeeding a baby, sometimes looking down to the infant and smiling.",
    emoji: "🤱",
  },
  {
    "web-scraper-order": "1666027639-2035",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫄 Pregnant Person",
    "people-href": "https://emojipedia.org/pregnant-person/",
    emojiName: "🫄 Pregnant Person",
    description:
      'A pregnant person holding their round stomach. Sometimes used in jest to represent feeling too full after overeating, as in a "food baby."',
    emoji: "🫄",
  },
  {
    "web-scraper-order": "1666027642-2036",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫃 Pregnant Man",
    "people-href": "https://emojipedia.org/pregnant-man/",
    emojiName: "🫃 Pregnant Man",
    description:
      'A pregnant man holding his round stomach. Sometimes used in jest to represent feeling too full after overeating, as in a "food baby."',
    emoji: "🫃",
  },
  {
    "web-scraper-order": "1666027646-2037",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤰 Pregnant Woman",
    "people-href": "https://emojipedia.org/pregnant-woman/",
    emojiName: "🤰 Pregnant Woman",
    description:
      'A pregnant woman holding her round stomach. Sometimes used in jest to represent feeling too full after overeating, as in a "food baby."',
    emoji: "🤰",
  },
  {
    "web-scraper-order": "1666027651-2038",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👰‍♀️ Woman with Veil",
    "people-href": "https://emojipedia.org/woman-with-veil/",
    emojiName: "👰‍♀️ Woman with Veil",
    description:
      "The Woman with Veil emoji is a ZWJ sequence combining 👰 Person with Veil, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "👰‍♀️",
  },
  {
    "web-scraper-order": "1666027656-2039",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👰‍♂️ Man with Veil",
    "people-href": "https://emojipedia.org/man-with-veil/",
    emojiName: "👰‍♂️ Man with Veil",
    description:
      "The Man with Veil emoji is a ZWJ sequence combining 👰 Person with Veil, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "👰‍♂️",
  },
  {
    "web-scraper-order": "1666027660-2040",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👰 Person with Veil",
    "people-href": "https://emojipedia.org/person-with-veil/",
    emojiName: "👰 Person with Veil",
    description:
      "A person in traditional western wedding dress with a veil over their head.",
    emoji: "👰",
  },
  {
    "web-scraper-order": "1666027664-2041",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤵‍♀️ Woman in Tuxedo",
    "people-href": "https://emojipedia.org/woman-in-tuxedo/",
    emojiName: "🤵‍♀️ Woman in Tuxedo",
    description:
      "The Woman in Tuxedo emoji is a ZWJ sequence combining 🤵 Person in Tuxedo, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤵‍♀️",
  },
  {
    "web-scraper-order": "1666027668-2042",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤵‍♂️ Man in Tuxedo",
    "people-href": "https://emojipedia.org/man-in-tuxedo/",
    emojiName: "🤵‍♂️ Man in Tuxedo",
    description:
      "The Man in Tuxedo emoji is a ZWJ sequence combining 🤵 Person in Tuxedo, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤵‍♂️",
  },
  {
    "web-scraper-order": "1666027671-2043",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤵 Person in Tuxedo",
    "people-href": "https://emojipedia.org/person-in-tuxedo/",
    emojiName: "🤵 Person in Tuxedo",
    description:
      "A person dressed for a formal occassion, wearing a tuxedo. No gender is specified for this emoji. See also Woman in Tuxedo and Man in Tuxedo.",
    emoji: "🤵",
  },
  {
    "web-scraper-order": "1666027674-2044",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧕 Woman with Headscarf",
    "people-href": "https://emojipedia.org/person-with-headscarf/",
    emojiName: "🧕 Woman with Headscarf",
    description:
      "A person (generally depicted as a woman) wearing a headscarf. While the type of  headscarf is not specified, this is most commonly displayed as a woman wearing a hijab.",
    emoji: "🧕",
  },
  {
    "web-scraper-order": "1666027677-2045",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👲 Person with Skullcap",
    "people-href": "https://emojipedia.org/person-with-skullcap/",
    emojiName: "👲 Person with Skullcap",
    description:
      "A person wearing a gua pi mao; a type of Chinese hat. Sometimes referred to as a skullcap.",
    emoji: "👲",
  },
  {
    "web-scraper-order": "1666027682-2046",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👳‍♀️ Woman Wearing Turban",
    "people-href": "https://emojipedia.org/woman-wearing-turban/",
    emojiName: "👳‍♀️ Woman Wearing Turban",
    description: "The female version of the 👳 Man Wearing Turban emoji.",
    emoji: "👳‍♀️",
  },
  {
    "web-scraper-order": "1666027687-2047",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👳‍♂️ Man Wearing Turban",
    "people-href": "https://emojipedia.org/man-wearing-turban/",
    emojiName: "👳‍♂️ Man Wearing Turban",
    description: "The male version of the 👳‍♀️ Woman Wearing Turban emoji.",
    emoji: "👳‍♂️",
  },
  {
    "web-scraper-order": "1666027693-2048",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👳 Person Wearing Turban",
    "people-href": "https://emojipedia.org/person-wearing-turban/",
    emojiName: "👳 Person Wearing Turban",
    description:
      "A man wearing a turban; a form of customary headwear worn by Sikhs or Muslims.",
    emoji: "👳",
  },
  {
    "web-scraper-order": "1666027697-2049",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👸 Princess",
    "people-href": "https://emojipedia.org/princess/",
    emojiName: "👸 Princess",
    description:
      "The face of a princess; a girl or woman wearing a small crown or tiara. Could also be used to represent a Queen or other royalty.",
    emoji: "👸",
  },
  {
    "web-scraper-order": "1666027701-2050",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤴 Prince",
    "people-href": "https://emojipedia.org/prince/",
    emojiName: "🤴 Prince",
    description:
      "Male royalty, intended as a gender pair for the princess emoji. Shown as a man with a crown.",
    emoji: "🤴",
  },
  {
    "web-scraper-order": "1666027704-2051",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫅 Person with Crown",
    "people-href": "https://emojipedia.org/person-with-crown/",
    emojiName: "🫅 Person with Crown",
    description: "A person wearing a crown.",
    emoji: "🫅",
  },
  {
    "web-scraper-order": "1666027708-2052",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👷‍♀️ Woman Construction Worker",
    "people-href": "https://emojipedia.org/woman-construction-worker/",
    emojiName: "👷‍♀️ Woman Construction Worker",
    description: "The female version of the 👷 Construction Worker emoji.",
    emoji: "👷‍♀️",
  },
  {
    "web-scraper-order": "1666027713-2053",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👷‍♂️ Man Construction Worker",
    "people-href": "https://emojipedia.org/man-construction-worker/",
    emojiName: "👷‍♂️ Man Construction Worker",
    description:
      "The male version of the 👷 Construction Worker emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "👷‍♂️",
  },
  {
    "web-scraper-order": "1666027716-2054",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👷 Construction Worker",
    "people-href": "https://emojipedia.org/construction-worker/",
    emojiName: "👷 Construction Worker",
    description:
      "A construction worker wearing a hard-hat (safety helmet). Has a high visibility vest or hammer in some variations.",
    emoji: "👷",
  },
  {
    "web-scraper-order": "1666027721-2055",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥷 Ninja",
    "people-href": "https://emojipedia.org/ninja/",
    emojiName: "🥷 Ninja",
    description:
      "A person dressed as a ninja with a black hood, a mask covering the lower half of their face, and the hilt of a knife or sword emerging from behind their shoulder.",
    emoji: "🥷",
  },
  {
    "web-scraper-order": "1666027726-2056",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💂‍♀️ Woman Guard",
    "people-href": "https://emojipedia.org/woman-guard/",
    emojiName: "💂‍♀️ Woman Guard",
    description: "The female version of the 💂 Guardsman emoji.",
    emoji: "💂‍♀️",
  },
  {
    "web-scraper-order": "1666027730-2057",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💂‍♂️ Man Guard",
    "people-href": "https://emojipedia.org/man-guard/",
    emojiName: "💂‍♂️ Man Guard",
    description:
      "The male version of the 💂 Guardsman emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "💂‍♂️",
  },
  {
    "web-scraper-order": "1666027733-2058",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💂 Guard",
    "people-href": "https://emojipedia.org/guard/",
    emojiName: "💂 Guard",
    description:
      "A British guardsman, known as a foot guard. Wears a tall black hat with a yellow chin-strap. Must look straight ahead at all times, even when tourists attempt to distract them.",
    emoji: "💂",
  },
  {
    "web-scraper-order": "1666027738-2059",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕵️‍♀️ Woman Detective",
    "people-href": "https://emojipedia.org/woman-detective/",
    emojiName: "🕵️‍♀️ Woman Detective",
    description: "The female version of the 🕵 Sleuth or Spy emoji.",
    emoji: "🕵️‍♀️",
  },
  {
    "web-scraper-order": "1666027743-2060",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕵️‍♂️ Man Detective",
    "people-href": "https://emojipedia.org/man-detective/",
    emojiName: "🕵️‍♂️ Man Detective",
    description:
      "The male version of the 🕵 Sleuth or Spy emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🕵️‍♂️",
  },
  {
    "web-scraper-order": "1666027748-2061",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕵️ Detective",
    "people-href": "https://emojipedia.org/detective/",
    emojiName: "🕵️ Detective",
    description:
      "An undercover investigator, wearing a hat, and sometimes using a magnifying glass to closely inspect evidence. This emoji did not originally recommend emoji modifiers, but a proposal was created to address this.",
    emoji: "🕵️",
  },
  {
    "web-scraper-order": "1666027753-2062",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👮‍♀️ Woman Police Officer",
    "people-href": "https://emojipedia.org/woman-police-officer/",
    emojiName: "👮‍♀️ Woman Police Officer",
    description: "The female version of the 👮 Police Officer emoji.",
    emoji: "👮‍♀️",
  },
  {
    "web-scraper-order": "1666027758-2063",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👮‍♂️ Man Police Officer",
    "people-href": "https://emojipedia.org/man-police-officer/",
    emojiName: "👮‍♂️ Man Police Officer",
    description:
      "The male version of the 👮 Police Officer emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "👮‍♂️",
  },
  {
    "web-scraper-order": "1666027762-2064",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👮 Police Officer",
    "people-href": "https://emojipedia.org/police-officer/",
    emojiName: "👮 Police Officer",
    description:
      "A police officer wearing a blue hat with a gold badge or shield in the middle.",
    emoji: "👮",
  },
  {
    "web-scraper-order": "1666027767-2065",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🚒 Woman Firefighter",
    "people-href": "https://emojipedia.org/woman-firefighter/",
    emojiName: "👩‍🚒 Woman Firefighter",
    description:
      "The Woman Firefighter emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🚒 Fire Engine.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🚒",
  },
  {
    "web-scraper-order": "1666027772-2066",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🚒 Man Firefighter",
    "people-href": "https://emojipedia.org/man-firefighter/",
    emojiName: "👨‍🚒 Man Firefighter",
    description:
      "The Man Firefighter emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🚒 Fire Engine.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🚒",
  },
  {
    "web-scraper-order": "1666027776-2067",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🚒 Firefighter",
    "people-href": "https://emojipedia.org/firefighter/",
    emojiName: "🧑‍🚒 Firefighter",
    description:
      "The Firefighter emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🚒 Fire Engine.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🚒",
  },
  {
    "web-scraper-order": "1666027781-2068",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🚀 Woman Astronaut",
    "people-href": "https://emojipedia.org/woman-astronaut/",
    emojiName: "👩‍🚀 Woman Astronaut",
    description:
      "A female astronaut or cosmonaut shown wearing a space suit and helmet.",
    emoji: "👩‍🚀",
  },
  {
    "web-scraper-order": "1666027785-2069",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🚀 Man Astronaut",
    "people-href": "https://emojipedia.org/man-astronaut/",
    emojiName: "👨‍🚀 Man Astronaut",
    description:
      "A male astronaut or cosmonaut shown wearing a space suit and helmet.",
    emoji: "👨‍🚀",
  },
  {
    "web-scraper-order": "1666027790-2070",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🚀 Astronaut",
    "people-href": "https://emojipedia.org/astronaut/",
    emojiName: "🧑‍🚀 Astronaut",
    description:
      "An astronaut or cosmonaut shown wearing a space suit and helmet.",
    emoji: "🧑‍🚀",
  },
  {
    "web-scraper-order": "1666027793-2071",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍✈️ Woman Pilot",
    "people-href": "https://emojipedia.org/woman-pilot/",
    emojiName: "👩‍✈️ Woman Pilot",
    description:
      "The Woman Pilot emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and ✈️ Airplane.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍✈️",
  },
  {
    "web-scraper-order": "1666027798-2072",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍✈️ Man Pilot",
    "people-href": "https://emojipedia.org/man-pilot/",
    emojiName: "👨‍✈️ Man Pilot",
    description:
      "The Man Pilot emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and ✈️ Airplane.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍✈️",
  },
  {
    "web-scraper-order": "1666027802-2073",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍✈️ Pilot",
    "people-href": "https://emojipedia.org/pilot/",
    emojiName: "🧑‍✈️ Pilot",
    description:
      "The Pilot emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and ✈️ Airplane.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍✈️",
  },
  {
    "web-scraper-order": "1666027805-2074",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🎨 Woman Artist",
    "people-href": "https://emojipedia.org/woman-artist/",
    emojiName: "👩‍🎨 Woman Artist",
    description:
      "The Woman Artist emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🎨 Artist Palette.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🎨",
  },
  {
    "web-scraper-order": "1666027809-2075",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🎨 Man Artist",
    "people-href": "https://emojipedia.org/man-artist/",
    emojiName: "👨‍🎨 Man Artist",
    description:
      "The Man Artist emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🎨 Artist Palette.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🎨",
  },
  {
    "web-scraper-order": "1666027814-2076",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎨 Artist",
    "people-href": "https://emojipedia.org/artist/",
    emojiName: "🧑‍🎨 Artist",
    description:
      "The Artist emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🎨 Artist Palette.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🎨",
  },
  {
    "web-scraper-order": "1666027817-2077",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🎤 Woman Singer",
    "people-href": "https://emojipedia.org/woman-singer/",
    emojiName: "👩‍🎤 Woman Singer",
    description:
      "A woman singer or rock star generally displayed with a microphone, and sometimes musical notes.",
    emoji: "👩‍🎤",
  },
  {
    "web-scraper-order": "1666027821-2078",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🎤 Man Singer",
    "people-href": "https://emojipedia.org/man-singer/",
    emojiName: "👨‍🎤 Man Singer",
    description:
      "A man singer or rock star generally displayed with a microphone, and sometimes musical notes.",
    emoji: "👨‍🎤",
  },
  {
    "web-scraper-order": "1666027825-2079",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎤 Singer",
    "people-href": "https://emojipedia.org/singer/",
    emojiName: "🧑‍🎤 Singer",
    description:
      "A singer or rock star generally displayed with a microphone, and sometimes musical notes.",
    emoji: "🧑‍🎤",
  },
  {
    "web-scraper-order": "1666027827-2080",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍💻 Woman Technologist",
    "people-href": "https://emojipedia.org/woman-technologist/",
    emojiName: "👩‍💻 Woman Technologist",
    description:
      "A woman behind a computer screen, working in the field of technology.",
    emoji: "👩‍💻",
  },
  {
    "web-scraper-order": "1666027830-2081",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍💻 Man Technologist",
    "people-href": "https://emojipedia.org/man-technologist/",
    emojiName: "👨‍💻 Man Technologist",
    description:
      "A man behind a computer screen, working in the field of technology.",
    emoji: "👨‍💻",
  },
  {
    "web-scraper-order": "1666027834-2082",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍💻 Technologist",
    "people-href": "https://emojipedia.org/technologist/",
    emojiName: "🧑‍💻 Technologist",
    description:
      "The Technologist emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 💻 Laptop.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍💻",
  },
  {
    "web-scraper-order": "1666027838-2083",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🔬 Woman Scientist",
    "people-href": "https://emojipedia.org/woman-scientist/",
    emojiName: "👩‍🔬 Woman Scientist",
    description:
      "The Woman Scientist emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🔬 Microscope.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🔬",
  },
  {
    "web-scraper-order": "1666027843-2084",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🔬 Man Scientist",
    "people-href": "https://emojipedia.org/man-scientist/",
    emojiName: "👨‍🔬 Man Scientist",
    description:
      "The Man Scientist emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🔬 Microscope.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🔬",
  },
  {
    "web-scraper-order": "1666027847-2085",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🔬 Scientist",
    "people-href": "https://emojipedia.org/scientist/",
    emojiName: "🧑‍🔬 Scientist",
    description:
      "The Scientist emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🔬 Microscope.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🔬",
  },
  {
    "web-scraper-order": "1666027850-2086",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍💼 Woman Office Worker",
    "people-href": "https://emojipedia.org/woman-office-worker/",
    emojiName: "👩‍💼 Woman Office Worker",
    description:
      "A woman wearing business attire. This may include items such as a shirt, blouse, tie, jacket, or headset.",
    emoji: "👩‍💼",
  },
  {
    "web-scraper-order": "1666027853-2087",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍💼 Man Office Worker",
    "people-href": "https://emojipedia.org/man-office-worker/",
    emojiName: "👨‍💼 Man Office Worker",
    description:
      "A man wearing business attire. This may include items such as a shirt, tie, jacket, or headset.",
    emoji: "👨‍💼",
  },
  {
    "web-scraper-order": "1666027857-2088",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍💼 Office Worker",
    "people-href": "https://emojipedia.org/office-worker/",
    emojiName: "🧑‍💼 Office Worker",
    description:
      "The Office Worker emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 💼 Briefcase.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍💼",
  },
  {
    "web-scraper-order": "1666027860-2089",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🏭 Woman Factory Worker",
    "people-href": "https://emojipedia.org/woman-factory-worker/",
    emojiName: "👩‍🏭 Woman Factory Worker",
    description:
      "The Woman Factory Worker emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🏭 Factory.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🏭",
  },
  {
    "web-scraper-order": "1666027865-2090",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🏭 Man Factory Worker",
    "people-href": "https://emojipedia.org/man-factory-worker/",
    emojiName: "👨‍🏭 Man Factory Worker",
    description:
      "The Man Factory Worker emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🏭 Factory.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🏭",
  },
  {
    "web-scraper-order": "1666027870-2091",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🏭 Factory Worker",
    "people-href": "https://emojipedia.org/factory-worker/",
    emojiName: "🧑‍🏭 Factory Worker",
    description:
      "The Factory Worker emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🏭 Factory.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🏭",
  },
  {
    "web-scraper-order": "1666027874-2092",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🔧 Woman Mechanic",
    "people-href": "https://emojipedia.org/woman-mechanic/",
    emojiName: "👩‍🔧 Woman Mechanic",
    description:
      "The Woman Mechanic emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🔧 Wrench.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🔧",
  },
  {
    "web-scraper-order": "1666027878-2093",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🔧 Man Mechanic",
    "people-href": "https://emojipedia.org/man-mechanic/",
    emojiName: "👨‍🔧 Man Mechanic",
    description:
      "The Man Mechanic emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🔧 Wrench.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🔧",
  },
  {
    "web-scraper-order": "1666027883-2094",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🔧 Mechanic",
    "people-href": "https://emojipedia.org/mechanic/",
    emojiName: "🧑‍🔧 Mechanic",
    description:
      "The Mechanic emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🔧 Wrench.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🔧",
  },
  {
    "web-scraper-order": "1666027887-2095",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🍳 Woman Cook",
    "people-href": "https://emojipedia.org/woman-cook/",
    emojiName: "👩‍🍳 Woman Cook",
    description:
      "The Woman Cook emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🍳 Cooking.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🍳",
  },
  {
    "web-scraper-order": "1666027892-2096",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🍳 Man Cook",
    "people-href": "https://emojipedia.org/man-cook/",
    emojiName: "👨‍🍳 Man Cook",
    description:
      "The Man Cook emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🍳 Cooking.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🍳",
  },
  {
    "web-scraper-order": "1666027897-2097",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🍳 Cook",
    "people-href": "https://emojipedia.org/cook/",
    emojiName: "🧑‍🍳 Cook",
    description:
      "The Cook emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🍳 Cooking.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🍳",
  },
  {
    "web-scraper-order": "1666027902-2098",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🌾 Woman Farmer",
    "people-href": "https://emojipedia.org/woman-farmer/",
    emojiName: "👩‍🌾 Woman Farmer",
    description:
      "The Woman Farmer emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🌾 Sheaf of Rice.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🌾",
  },
  {
    "web-scraper-order": "1666027906-2099",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🌾 Man Farmer",
    "people-href": "https://emojipedia.org/man-farmer/",
    emojiName: "👨‍🌾 Man Farmer",
    description:
      "The Man Farmer emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🌾 Sheaf of Rice.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🌾",
  },
  {
    "web-scraper-order": "1666027911-2100",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🌾 Farmer",
    "people-href": "https://emojipedia.org/farmer/",
    emojiName: "🧑‍🌾 Farmer",
    description:
      "The Farmer emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🌾 Sheaf of Rice.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🌾",
  },
  {
    "web-scraper-order": "1666027916-2101",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍⚖️ Woman Judge",
    "people-href": "https://emojipedia.org/woman-judge/",
    emojiName: "👩‍⚖️ Woman Judge",
    description:
      "The Woman Judge emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and ⚖️ Balance Scale.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍⚖️",
  },
  {
    "web-scraper-order": "1666027921-2102",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍⚖️ Man Judge",
    "people-href": "https://emojipedia.org/man-judge/",
    emojiName: "👨‍⚖️ Man Judge",
    description:
      "The Man Judge emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and ⚖️ Balance Scale.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍⚖️",
  },
  {
    "web-scraper-order": "1666027925-2103",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍⚖️ Judge",
    "people-href": "https://emojipedia.org/judge/",
    emojiName: "🧑‍⚖️ Judge",
    description:
      "The Judge emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and ⚖️ Balance Scale.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍⚖️",
  },
  {
    "web-scraper-order": "1666027930-2104",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🏫 Woman Teacher",
    "people-href": "https://emojipedia.org/woman-teacher/",
    emojiName: "👩‍🏫 Woman Teacher",
    description:
      "A woman standing in front of a chalkboard (aka blackboard) with the intention of teaching a class. Often shown holding a 📕 Closed Book or a pointer.",
    emoji: "👩‍🏫",
  },
  {
    "web-scraper-order": "1666027935-2105",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🏫 Man Teacher",
    "people-href": "https://emojipedia.org/man-teacher/",
    emojiName: "👨‍🏫 Man Teacher",
    description:
      "A man standing in front of a chalkboard (aka blackboard) with the intention of teaching a class. Often shown holding a 📕 Closed Book or a pointer.",
    emoji: "👨‍🏫",
  },
  {
    "web-scraper-order": "1666027939-2106",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🏫 Teacher",
    "people-href": "https://emojipedia.org/teacher/",
    emojiName: "🧑‍🏫 Teacher",
    description:
      "A person standing in front of a chalkboard (aka blackboard) with the intention of teaching a class. Often shown holding a 📕 Closed Book or a pointer.",
    emoji: "🧑‍🏫",
  },
  {
    "web-scraper-order": "1666027943-2107",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🎓 Woman Student",
    "people-href": "https://emojipedia.org/woman-student/",
    emojiName: "👩‍🎓 Woman Student",
    description:
      "The Woman Student emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🎓 Graduation Cap.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🎓",
  },
  {
    "web-scraper-order": "1666027948-2108",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🎓 Man Student",
    "people-href": "https://emojipedia.org/man-student/",
    emojiName: "👨‍🎓 Man Student",
    description:
      "The Man Student emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🎓 Graduation Cap.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🎓",
  },
  {
    "web-scraper-order": "1666027952-2109",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎓 Student",
    "people-href": "https://emojipedia.org/student/",
    emojiName: "🧑‍🎓 Student",
    description:
      "The Student emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🎓 Graduation Cap.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🎓",
  },
  {
    "web-scraper-order": "1666027957-2110",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍⚕️ Woman Health Worker",
    "people-href": "https://emojipedia.org/woman-health-worker/",
    emojiName: "👩‍⚕️ Woman Health Worker",
    description:
      "A woman working in the field of health care. This may be used to represent a doctor, nurse, or pharmacist.",
    emoji: "👩‍⚕️",
  },
  {
    "web-scraper-order": "1666027961-2111",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍⚕️ Man Health Worker",
    "people-href": "https://emojipedia.org/man-health-worker/",
    emojiName: "👨‍⚕️ Man Health Worker",
    description:
      "A man working in the field of health care. This may be used to represent a doctor, nurse, or pharmacist.",
    emoji: "👨‍⚕️",
  },
  {
    "web-scraper-order": "1666027966-2112",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍⚕️ Health Worker",
    "people-href": "https://emojipedia.org/health-worker/",
    emojiName: "🧑‍⚕️ Health Worker",
    description:
      "The Health Worker emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and ⚕️ Medical Symbol.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍⚕️",
  },
  {
    "web-scraper-order": "1666027992-2113",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤷‍♀️ Woman Shrugging",
    "people-href": "https://emojipedia.org/woman-shrugging/",
    emojiName: "🤷‍♀️ Woman Shrugging",
    description:
      "The Woman Shrugging emoji is a ZWJ sequence combining 🤷 Person Shrugging, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤷‍♀️",
  },
  {
    "web-scraper-order": "1666027997-2114",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤷‍♂️ Man Shrugging",
    "people-href": "https://emojipedia.org/man-shrugging/",
    emojiName: "🤷‍♂️ Man Shrugging",
    description:
      "The Man Shrugging emoji is a ZWJ sequence combining 🤷 Person Shrugging, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤷‍♂️",
  },
  {
    "web-scraper-order": "1666028001-2115",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤷 Person Shrugging",
    "people-href": "https://emojipedia.org/person-shrugging/",
    emojiName: "🤷 Person Shrugging",
    description:
      "A person shrugging their shoulders to indicate a lack of knowledge about a particular topic, or a lack of care about the result of a situation.",
    emoji: "🤷",
  },
  {
    "web-scraper-order": "1666028005-2116",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤦‍♀️ Woman Facepalming",
    "people-href": "https://emojipedia.org/woman-facepalming/",
    emojiName: "🤦‍♀️ Woman Facepalming",
    description:
      "The Woman Facepalming emoji is a ZWJ sequence combining 🤦 Person Facepalming, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤦‍♀️",
  },
  {
    "web-scraper-order": "1666028009-2117",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤦‍♂️ Man Facepalming",
    "people-href": "https://emojipedia.org/man-facepalming/",
    emojiName: "🤦‍♂️ Man Facepalming",
    description:
      "The Man Facepalming emoji is a ZWJ sequence combining 🤦 Person Facepalming, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤦‍♂️",
  },
  {
    "web-scraper-order": "1666028013-2118",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤦 Person Facepalming",
    "people-href": "https://emojipedia.org/person-facepalming/",
    emojiName: "🤦 Person Facepalming",
    description:
      "A hand shown pressing against the head of a person, commonly written as facepalm. Used to display frustration or embarrassment at the ineptitude of a person or situation.",
    emoji: "🤦",
  },
  {
    "web-scraper-order": "1666028018-2119",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙇‍♀️ Woman Bowing",
    "people-href": "https://emojipedia.org/woman-bowing/",
    emojiName: "🙇‍♀️ Woman Bowing",
    description: "The female version of the 🙇 Person Bowing Deeply emoji.",
    emoji: "🙇‍♀️",
  },
  {
    "web-scraper-order": "1666028022-2120",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙇‍♂️ Man Bowing",
    "people-href": "https://emojipedia.org/man-bowing/",
    emojiName: "🙇‍♂️ Man Bowing",
    description:
      "The male version of the 🙇 Person Bowing Deeply emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙇‍♂️",
  },
  {
    "web-scraper-order": "1666028027-2121",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙇 Person Bowing",
    "people-href": "https://emojipedia.org/person-bowing/",
    emojiName: "🙇 Person Bowing",
    description:
      "A person bowing deeply which is known as dogeza in Japan. Used to express a sincere apology, or to request a large favour.",
    emoji: "🙇",
  },
  {
    "web-scraper-order": "1666028029-2122",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧏‍♀️ Deaf Woman",
    "people-href": "https://emojipedia.org/deaf-woman/",
    emojiName: "🧏‍♀️ Deaf Woman",
    description:
      "The Deaf Woman emoji is a ZWJ sequence combining 🧏 Deaf Person, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧏‍♀️",
  },
  {
    "web-scraper-order": "1666028032-2123",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧏‍♂️ Deaf Man",
    "people-href": "https://emojipedia.org/deaf-man/",
    emojiName: "🧏‍♂️ Deaf Man",
    description:
      "The Deaf Man emoji is a ZWJ sequence combining 🧏 Deaf Person, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧏‍♂️",
  },
  {
    "web-scraper-order": "1666028034-2124",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧏 Deaf Person",
    "people-href": "https://emojipedia.org/deaf-person/",
    emojiName: "🧏 Deaf Person",
    description:
      "A person gesturing with their index finger between ear and mouth, used as a deaf sign in American Sign Language (ASL) and a number of other global sign languages. See also 🦻 Ear With Hearing Aid.",
    emoji: "🧏",
  },
  {
    "web-scraper-order": "1666028039-2125",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙋‍♀️ Woman Raising Hand",
    "people-href": "https://emojipedia.org/woman-raising-hand/",
    emojiName: "🙋‍♀️ Woman Raising Hand",
    description:
      "The female version of the 🙋 Happy Person Raising One Hand emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙋‍♀️",
  },
  {
    "web-scraper-order": "1666028044-2126",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙋‍♂️ Man Raising Hand",
    "people-href": "https://emojipedia.org/man-raising-hand/",
    emojiName: "🙋‍♂️ Man Raising Hand",
    description:
      "The man version of the 🙋 Happy Person Raising One Hand emoji.",
    emoji: "🙋‍♂️",
  },
  {
    "web-scraper-order": "1666028049-2127",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙋 Person Raising Hand",
    "people-href": "https://emojipedia.org/person-raising-hand/",
    emojiName: "🙋 Person Raising Hand",
    description:
      "A person with its hand in the air, as if it wants to ask or answer a question.",
    emoji: "🙋",
  },
  {
    "web-scraper-order": "1666028052-2128",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💁‍♀️ Woman Tipping Hand",
    "people-href": "https://emojipedia.org/woman-tipping-hand/",
    emojiName: "💁‍♀️ Woman Tipping Hand",
    description:
      "A woman tipping her hand by her shoulder as if she’s carrying a tray of drinks or flipping her hair.",
    emoji: "💁‍♀️",
  },
  {
    "web-scraper-order": "1666028056-2129",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💁‍♂️ Man Tipping Hand",
    "people-href": "https://emojipedia.org/man-tipping-hand/",
    emojiName: "💁‍♂️ Man Tipping Hand",
    description:
      "A man tipping his hand by his shoulder as if he’s carrying a tray of drinks or flipping his hair.",
    emoji: "💁‍♂️",
  },
  {
    "web-scraper-order": "1666028061-2130",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💁 Person Tipping Hand",
    "people-href": "https://emojipedia.org/person-tipping-hand/",
    emojiName: "💁 Person Tipping Hand",
    description:
      "A person tipping their hand by their shoulder as if they’re carrying a tray of drinks or flipping their hair. Originally called Information Desk Person.",
    emoji: "💁",
  },
  {
    "web-scraper-order": "1666028066-2131",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙆‍♀️ Woman Gesturing OK",
    "people-href": "https://emojipedia.org/woman-gesturing-ok/",
    emojiName: "🙆‍♀️ Woman Gesturing OK",
    description:
      "The female version of the 🙆 Face With OK Gesture emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙆‍♀️",
  },
  {
    "web-scraper-order": "1666028072-2132",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙆‍♂️ Man Gesturing OK",
    "people-href": "https://emojipedia.org/man-gesturing-ok/",
    emojiName: "🙆‍♂️ Man Gesturing OK",
    description: "The male version of the 🙆 Face With OK Gesture emoji.",
    emoji: "🙆‍♂️",
  },
  {
    "web-scraper-order": "1666028077-2133",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙆 Person Gesturing OK",
    "people-href": "https://emojipedia.org/person-gesturing-ok/",
    emojiName: "🙆 Person Gesturing OK",
    description:
      "A person with arms above their head, making an ‘OK’ sign (circle) with the whole body. No gender is specified.",
    emoji: "🙆",
  },
  {
    "web-scraper-order": "1666028082-2134",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙅‍♀️ Woman Gesturing No",
    "people-href": "https://emojipedia.org/woman-gesturing-no/",
    emojiName: "🙅‍♀️ Woman Gesturing No",
    description:
      "A woman with arms crossed forming an ‘X’ to indicate ‘no’ or ‘no good’. This motion is used on the TV game show Deal or No Deal to indicate ‘No Deal’. Intended to be gender-neutral but shown as a woman on most platforms.",
    emoji: "🙅‍♀️",
  },
  {
    "web-scraper-order": "1666028087-2135",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙅‍♂️ Man Gesturing No",
    "people-href": "https://emojipedia.org/man-gesturing-no/",
    emojiName: "🙅‍♂️ Man Gesturing No",
    description:
      "A woman with arms crossed forming an ‘X’ to indicate ‘no’ or ‘no good’. This motion is used on the TV game show Deal or No Deal to indicate ‘No Deal’. Intended to be gender-neutral but shown as a woman on most platforms.",
    emoji: "🙅‍♂️",
  },
  {
    "web-scraper-order": "1666028092-2136",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙅 Person Gesturing No",
    "people-href": "https://emojipedia.org/person-gesturing-no/",
    emojiName: "🙅 Person Gesturing No",
    description:
      "A person with arms crossed forming an ‘X’ to indicate ‘no’ or ‘no good’. This motion is used on the TV game show Deal or No Deal to indicate ‘No Deal’.",
    emoji: "🙅",
  },
  {
    "web-scraper-order": "1666028096-2137",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙎‍♀️ Woman Pouting",
    "people-href": "https://emojipedia.org/woman-pouting/",
    emojiName: "🙎‍♀️ Woman Pouting",
    description:
      "The female version of the 🙎 Person With Pouting Face emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙎‍♀️",
  },
  {
    "web-scraper-order": "1666028101-2138",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙎‍♂️ Man Pouting",
    "people-href": "https://emojipedia.org/man-pouting/",
    emojiName: "🙎‍♂️ Man Pouting",
    description: "The male version of the 🙎 Person With Pouting Face emoji.",
    emoji: "🙎‍♂️",
  },
  {
    "web-scraper-order": "1666028104-2139",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙎 Person Pouting",
    "people-href": "https://emojipedia.org/person-pouting/",
    emojiName: "🙎 Person Pouting",
    description:
      "A person with a serious expression, showing mild displeasure with the situation. Could be considered to be reserved or stoic in response, as this person is not visible angry.",
    emoji: "🙎",
  },
  {
    "web-scraper-order": "1666028109-2140",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙍‍♀️ Woman Frowning",
    "people-href": "https://emojipedia.org/woman-frowning/",
    emojiName: "🙍‍♀️ Woman Frowning",
    description:
      "The female version of the 🙍 Person Frowning emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙍‍♀️",
  },
  {
    "web-scraper-order": "1666028113-2141",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙍‍♂️ Man Frowning",
    "people-href": "https://emojipedia.org/man-frowning/",
    emojiName: "🙍‍♂️ Man Frowning",
    description: "The male version of the 🙍 Person Frowning emoji.",
    emoji: "🙍‍♂️",
  },
  {
    "web-scraper-order": "1666028118-2142",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙍 Person Frowning",
    "people-href": "https://emojipedia.org/person-frowning/",
    emojiName: "🙍 Person Frowning",
    description:
      "An upset person, frowning with dismay. Gender is not specified, but generally shown as a woman.",
    emoji: "🙍",
  },
  {
    "web-scraper-order": "1666028122-2143",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👵 Old Woman",
    "people-href": "https://emojipedia.org/old-woman/",
    emojiName: "👵 Old Woman",
    description:
      "An elderly woman with gray (grey) hair, and visible wrinkles. Wears glasses on some platforms.",
    emoji: "👵",
  },
  {
    "web-scraper-order": "1666028126-2144",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👴 Old Man",
    "people-href": "https://emojipedia.org/old-man/",
    emojiName: "👴 Old Man",
    description:
      "An elderly man gray (grey) hair, and visible wrinkles. Balding in many versions of this artwork, such as Apple and Microsoft designs.",
    emoji: "👴",
  },
  {
    "web-scraper-order": "1666028131-2145",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧓 Older Person",
    "people-href": "https://emojipedia.org/older-person/",
    emojiName: "🧓 Older Person",
    description:
      "An older adult with no gender specified. This emoji may be used to talk about older adults in a gender-inclusive way.",
    emoji: "🧓",
  },
  {
    "web-scraper-order": "1666028136-2146",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👱‍♂️ Man: Blond Hair",
    "people-href": "https://emojipedia.org/man-blond-hair/",
    emojiName: "👱‍♂️ Man: Blond Hair",
    description: "The male version of 👱 Person with Blond Hair.",
    emoji: "👱‍♂️",
  },
  {
    "web-scraper-order": "1666028142-2147",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👱‍♀️ Woman: Blond Hair",
    "people-href": "https://emojipedia.org/woman-blond-hair/",
    emojiName: "👱‍♀️ Woman: Blond Hair",
    description: "The female version of 👱 Person with Blond Hair.",
    emoji: "👱‍♀️",
  },
  {
    "web-scraper-order": "1666028147-2148",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦲 Person: Bald",
    "people-href": "https://emojipedia.org/person-bald/",
    emojiName: "🧑‍🦲 Person: Bald",
    description:
      "A person with a bald head. Can be used to represent a bald person or a person with a shaved head. May also be used to represent a person experiencing hair loss from chemotherapy, alopecia, or other medical treatments or conditions.",
    emoji: "🧑‍🦲",
  },
  {
    "web-scraper-order": "1666028151-2149",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦲 Woman: Bald",
    "people-href": "https://emojipedia.org/woman-bald/",
    emojiName: "👩‍🦲 Woman: Bald",
    description:
      "A woman with a bald head. Can be used to represent a bald woman or a woman with a shaved head. May also be used to represent a woman experiencing hair loss from chemotherapy, alopecia, or other medical treatments or conditions.",
    emoji: "👩‍🦲",
  },
  {
    "web-scraper-order": "1666028156-2150",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦳 Person: White Hair",
    "people-href": "https://emojipedia.org/person-white-hair/",
    emojiName: "🧑‍🦳 Person: White Hair",
    description:
      "A person with white hair. This emoji maintains white hair no matter which skin tone is chosen. This emoji may be used to talk about people with white hair in a gender-inclusive way.",
    emoji: "🧑‍🦳",
  },
  {
    "web-scraper-order": "1666028162-2151",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦳 Woman: White Hair",
    "people-href": "https://emojipedia.org/woman-white-hair/",
    emojiName: "👩‍🦳 Woman: White Hair",
    description: "The female version of 🧑‍🦳 Person with White Hair.",
    emoji: "👩‍🦳",
  },
  {
    "web-scraper-order": "1666028170-2152",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦱 Person: Curly Hair",
    "people-href": "https://emojipedia.org/person-curly-hair/",
    emojiName: "🧑‍🦱 Person: Curly Hair",
    description:
      "A person with curly hair. This emoji may be used to talk about people with curly hair in a gender-inclusive way.",
    emoji: "🧑‍🦱",
  },
  {
    "web-scraper-order": "1666028180-2153",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦱 Woman: Curly Hair",
    "people-href": "https://emojipedia.org/woman-curly-hair/",
    emojiName: "👩‍🦱 Woman: Curly Hair",
    description: "The female version of 🧑‍🦱 Person with Curly Hair.",
    emoji: "👩‍🦱",
  },
  {
    "web-scraper-order": "1666028184-2154",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦰 Person: Red Hair",
    "people-href": "https://emojipedia.org/person-red-hair/",
    emojiName: "🧑‍🦰 Person: Red Hair",
    description:
      "A person with red hair. This emoji maintains red hair no matter which skin tone is chosen. This emoji may be used to talk about redheads in a gender-inclusive way.",
    emoji: "🧑‍🦰",
  },
  {
    "web-scraper-order": "1666028190-2155",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦰 Woman: Red Hair",
    "people-href": "https://emojipedia.org/woman-red-hair/",
    emojiName: "👩‍🦰 Woman: Red Hair",
    description: "The female version of 🧑‍🦰 Person with Red Hair.",
    emoji: "👩‍🦰",
  },
  {
    "web-scraper-order": "1666028195-2156",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩 Woman",
    "people-href": "https://emojipedia.org/woman/",
    emojiName: "👩 Woman",
    description: "The female version of 🧑 Person.",
    emoji: "👩",
  },
  {
    "web-scraper-order": "1666028199-2157",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦲 Man: Bald",
    "people-href": "https://emojipedia.org/man-bald/",
    emojiName: "👨‍🦲 Man: Bald",
    description: "The male version of 🧑‍🦲 Blad Person.",
    emoji: "👨‍🦲",
  },
  {
    "web-scraper-order": "1666028204-2158",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦳 Man: White Hair",
    "people-href": "https://emojipedia.org/man-white-hair/",
    emojiName: "👨‍🦳 Man: White Hair",
    description: "The male version of 🧑‍🦳 Person with White Hair.",
    emoji: "👨‍🦳",
  },
  {
    "web-scraper-order": "1666028210-2159",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦱 Man: Curly Hair",
    "people-href": "https://emojipedia.org/man-curly-hair/",
    emojiName: "👨‍🦱 Man: Curly Hair",
    description: "The male version of 🧑‍🦱 Person with Curly Hair.",
    emoji: "👨‍🦱",
  },
  {
    "web-scraper-order": "1666028214-2160",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦰 Man: Red Hair",
    "people-href": "https://emojipedia.org/man-red-hair/",
    emojiName: "👨‍🦰 Man: Red Hair",
    description: "The male version of 🧑‍🦰 Person with Red Hair.",
    emoji: "👨‍🦰",
  },
  {
    "web-scraper-order": "1666028219-2161",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧔 Person: Beard",
    "people-href": "https://emojipedia.org/person-beard/",
    emojiName: "🧔 Person: Beard",
    description: "A person with a beard.",
    emoji: "🧔",
  },
  {
    "web-scraper-order": "1666028222-2162",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨 Man",
    "people-href": "https://emojipedia.org/man/",
    emojiName: "👨 Man",
    description: "The male version of 🧑 Person.",
    emoji: "👨",
  },
  {
    "web-scraper-order": "1666028227-2163",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👱 Person: Blond Hair",
    "people-href": "https://emojipedia.org/person-blond-hair/",
    emojiName: "👱 Person: Blond Hair",
    description:
      "A person with blond hair. This emoji maintains blond hair no matter which skin tone is chosen. This emoji may be used to talk about blonds in a gender-inclusive way.",
    emoji: "👱",
  },
  {
    "web-scraper-order": "1666028232-2164",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑 Person",
    "people-href": "https://emojipedia.org/person/",
    emojiName: "🧑 Person",
    description:
      "An adult with no gender specified. This emoji may be used to talk about adults in a gender-inclusive way.",
    emoji: "🧑",
  },
  {
    "web-scraper-order": "1666028237-2165",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👧 Girl",
    "people-href": "https://emojipedia.org/girl/",
    emojiName: "👧 Girl",
    description:
      "The face of a girl, smiling. Most platforms feature the girl's hair in pigtails.",
    emoji: "👧",
  },
  {
    "web-scraper-order": "1666028242-2166",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👦 Boy",
    "people-href": "https://emojipedia.org/boy/",
    emojiName: "👦 Boy",
    description: "The face of a boy, smiling.",
    emoji: "👦",
  },
  {
    "web-scraper-order": "1666028247-2167",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧒 Child",
    "people-href": "https://emojipedia.org/child/",
    emojiName: "🧒 Child",
    description:
      "A child with no gender specified. This emoji may be used to talk about children in a gender-inclusive way.",
    emoji: "🧒",
  },
  {
    "web-scraper-order": "1666028251-2168",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👶 Baby",
    "people-href": "https://emojipedia.org/baby/",
    emojiName: "👶 Baby",
    description:
      "The face of a baby with a small tuft of hair on top of its head. Some platforms show the baby sucking on a pacifier, and some platforms show a single tooth in the baby’s open mouth. Android previously displayed this emoji as a swaddled baby.",
    emoji: "👶",
  },
  {
    "web-scraper-order": "1666028253-2169",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫦 Biting Lip",
    "people-href": "https://emojipedia.org/biting-lip/",
    emojiName: "🫦 Biting Lip",
    description:
      "A mouth with the top teeth biting down on one side of the lower lip.",
    emoji: "🫦",
  },
  {
    "web-scraper-order": "1666028257-2170",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👄 Mouth",
    "people-href": "https://emojipedia.org/mouth/",
    emojiName: "👄 Mouth",
    description:
      "A human mouth which is generally displayed as a pair of lips and a top row of teeth, instead of the inside of the mouth.",
    emoji: "👄",
  },
  {
    "web-scraper-order": "1666028260-2171",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👅 Tongue",
    "people-href": "https://emojipedia.org/tongue/",
    emojiName: "👅 Tongue",
    description:
      "A tongue, sticking out. May be used as a childish sign of defiance. Alternatively: licking, in various contexts.",
    emoji: "👅",
  },
  {
    "web-scraper-order": "1666028264-2172",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👁️ Eye",
    "people-href": "https://emojipedia.org/eye/",
    emojiName: "👁️ Eye",
    description:
      "A single human eye, looking forward. This eye is in a different shape and style to the pair of eyes, which are more rounded, and looking to one side.",
    emoji: "👁️",
  },
  {
    "web-scraper-order": "1666028267-2173",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👀 Eyes",
    "people-href": "https://emojipedia.org/eyes/",
    emojiName: "👀 Eyes",
    description:
      "A pair of eyes, glancing slightly to the left on most platforms. The Google version of this emoji previously showed only a single eye, despite the emojiName of this character being eyes (plural).",
    emoji: "👀",
  },
  {
    "web-scraper-order": "1666028270-2174",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦴 Bone",
    "people-href": "https://emojipedia.org/bone/",
    emojiName: "🦴 Bone",
    description:
      "A bone which may be used for a dog to chew on, or as a part of the human body. The type of bone is not specified.",
    emoji: "🦴",
  },
  {
    "web-scraper-order": "1666028274-2175",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦷 Tooth",
    "people-href": "https://emojipedia.org/tooth/",
    emojiName: "🦷 Tooth",
    description:
      "Tooth was approved as part of Unicode 11.0 in 2018 and added to Emoji 11.0 in 2018.",
    emoji: "🦷",
  },
  {
    "web-scraper-order": "1666028279-2176",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫁 Lungs",
    "people-href": "https://emojipedia.org/lungs/",
    emojiName: "🫁 Lungs",
    description:
      "Pink anatomical lungs and trachea, shown with bronchial tubes on some platforms. Used in medical contexts to talk about lung health. Sometimes used in reference to taking deep breaths, hyperventilating, or breathing in general. Also used in the context of smoking or vaping.",
    emoji: "🫁",
  },
  {
    "web-scraper-order": "1666028282-2177",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫀 Anatomical Heart",
    "people-href": "https://emojipedia.org/anatomical-heart/",
    emojiName: "🫀 Anatomical Heart",
    description:
      "A red anatomical heart, shown with blue or purple veins on some platforms.",
    emoji: "🫀",
  },
  {
    "web-scraper-order": "1666028284-2178",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧠 Brain",
    "people-href": "https://emojipedia.org/brain/",
    emojiName: "🧠 Brain",
    description:
      "A human brain, shown in pink on most platforms. Used to indicate thinking or the human mind.",
    emoji: "🧠",
  },
  {
    "web-scraper-order": "1666028286-2179",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👃 Nose",
    "people-href": "https://emojipedia.org/nose/",
    emojiName: "👃 Nose",
    description:
      "A human nose. May be used to indicate smelling, or something that smells.",
    emoji: "👃",
  },
  {
    "web-scraper-order": "1666028291-2180",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦻 Ear with Hearing Aid",
    "people-href": "https://emojipedia.org/ear-with-hearing-aid/",
    emojiName: "🦻 Ear with Hearing Aid",
    description:
      "An ear shown with a hearing aid, worn by a person with hearing loss. The style shown in Behind The Ear (BTE), but this can represent any form of hearing aid.",
    emoji: "🦻",
  },
  {
    "web-scraper-order": "1666028294-2181",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👂 Ear",
    "people-href": "https://emojipedia.org/ear/",
    emojiName: "👂 Ear",
    description:
      "A single human ear. May be used in the context of listening, or hearing something.",
    emoji: "👂",
  },
  {
    "web-scraper-order": "1666028298-2182",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦶 Foot",
    "people-href": "https://emojipedia.org/foot/",
    emojiName: "🦶 Foot",
    description:
      "A human foot shown with five toes and may include part or all of the ankle. Shown on Apple platforms as the sole of a foot.",
    emoji: "🦶",
  },
  {
    "web-scraper-order": "1666028300-2183",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦵 Leg",
    "people-href": "https://emojipedia.org/leg/",
    emojiName: "🦵 Leg",
    description:
      "A human leg, shown detached from a human body. Displayed from the thigh and may include the foot.",
    emoji: "🦵",
  },
  {
    "web-scraper-order": "1666028303-2184",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦿 Mechanical Leg",
    "people-href": "https://emojipedia.org/mechanical-leg/",
    emojiName: "🦿 Mechanical Leg",
    description: "A mechanical or prosthetic leg.",
    emoji: "🦿",
  },
  {
    "web-scraper-order": "1666028307-2185",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦾 Mechanical Arm",
    "people-href": "https://emojipedia.org/mechanical-arm/",
    emojiName: "🦾 Mechanical Arm",
    description: "A mechanical or prosthetic arm.",
    emoji: "🦾",
  },
  {
    "web-scraper-order": "1666028311-2186",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💪 Flexed Biceps",
    "people-href": "https://emojipedia.org/flexed-biceps/",
    emojiName: "💪 Flexed Biceps",
    description:
      "An arm flexing to show its biceps muscle. Represents strength, or working out.",
    emoji: "💪",
  },
  {
    "web-scraper-order": "1666028315-2187",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤳 Selfie",
    "people-href": "https://emojipedia.org/selfie/",
    emojiName: "🤳 Selfie",
    description:
      "A mobile phone held up to take a selfie (photo of the person holding the phone or camera). Generally represented as a disembodied arm holding a mobile phone.",
    emoji: "🤳",
  },
  {
    "web-scraper-order": "1666028318-2188",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💅 Nail Polish",
    "people-href": "https://emojipedia.org/nail-polish/",
    emojiName: "💅 Nail Polish",
    description:
      "Colored nail polish being applied to finger nails, often used to display an air of nonchalance or indifference.",
    emoji: "💅",
  },
  {
    "web-scraper-order": "1666028322-2189",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✍️ Writing Hand",
    "people-href": "https://emojipedia.org/writing-hand/",
    emojiName: "✍️ Writing Hand",
    description:
      "A hand holding a pen or pencil and writing. Most often shown as holding either a blue or black pen, though Microsoft's design has a red pen. LG's design displays a left hand, while all other platforms show a right hand. Used broadly to represent writing.",
    emoji: "✍️",
  },
  {
    "web-scraper-order": "1666028327-2190",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙏 Folded Hands",
    "people-href": "https://emojipedia.org/folded-hands/",
    emojiName: "🙏 Folded Hands",
    description:
      "Two hands placed firmly together, meaning please or thank you in Japanese culture. A common alternative use for this emoji is for prayer, using the same gesture as praying hands. It can also represent a respectful greeting or show of adoration many in Southeast Asian religions and cultures, such as the Hindu namaste or Buddhist añjali mudra.",
    emoji: "🙏",
  },
  {
    "web-scraper-order": "1666028332-2191",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤝 Handshake",
    "people-href": "https://emojipedia.org/handshake/",
    emojiName: "🤝 Handshake",
    description:
      "Two hands performing a handshake gesture, indicating a cordial greeting between friends or associates.",
    emoji: "🤝",
  },
  {
    "web-scraper-order": "1666028337-2192",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤲 Palms Up Together",
    "people-href": "https://emojipedia.org/palms-up-together/",
    emojiName: "🤲 Palms Up Together",
    description:
      "Two hands held out together with open palms facing up, in a slightly cupped manner.",
    emoji: "🤲",
  },
  {
    "web-scraper-order": "1666028341-2193",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👐 Open Hands",
    "people-href": "https://emojipedia.org/open-hands/",
    emojiName: "👐 Open Hands",
    description:
      "Two open hands, representing openness. Sometimes used as a hug, or as a display of jazz hands.",
    emoji: "👐",
  },
  {
    "web-scraper-order": "1666028346-2194",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫶 Heart Hands",
    "people-href": "https://emojipedia.org/heart-hands/",
    emojiName: "🫶 Heart Hands",
    description:
      "Two hands forming a heart shape. Used to express love and support.",
    emoji: "🫶",
  },
  {
    "web-scraper-order": "1666028350-2195",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙌 Raising Hands",
    "people-href": "https://emojipedia.org/raising-hands/",
    emojiName: "🙌 Raising Hands",
    description:
      "Two hands raised in the air, celebrating success or another joyous event.",
    emoji: "🙌",
  },
  {
    "web-scraper-order": "1666028353-2196",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👏 Clapping Hands",
    "people-href": "https://emojipedia.org/clapping-hands/",
    emojiName: "👏 Clapping Hands",
    description:
      "Two hands clapping emoji, which when used multiple times can be used as a round of applause.",
    emoji: "👏",
  },
  {
    "web-scraper-order": "1666028356-2197",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤜 Right-Facing Fist",
    "people-href": "https://emojipedia.org/right-facing-fist/",
    emojiName: "🤜 Right-Facing Fist",
    description:
      "A fist pointing right, which may be used in conjunction with the left-facing fist to complete a fist-bump gesture.",
    emoji: "🤜",
  },
  {
    "web-scraper-order": "1666028359-2198",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤛 Left-Facing Fist",
    "people-href": "https://emojipedia.org/left-facing-fist/",
    emojiName: "🤛 Left-Facing Fist",
    description:
      "A fist pointing left, which may be used in conjunction with the right-facing fist to complete a fist-bump gesture.",
    emoji: "🤛",
  },
  {
    "web-scraper-order": "1666028363-2199",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👊 Oncoming Fist",
    "people-href": "https://emojipedia.org/oncoming-fist/",
    emojiName: "👊 Oncoming Fist",
    description:
      "A fist displayed in a position to punch someone, or to fist-bump another person.",
    emoji: "👊",
  },
  {
    "web-scraper-order": "1666028366-2200",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✊ Raised Fist",
    "people-href": "https://emojipedia.org/raised-fist/",
    emojiName: "✊ Raised Fist",
    description:
      "A fist raised in the air that may be used as a celebratory gesture: the fist pump. Can also be used to represent zero items, due to a lack of any fingers being held up.",
    emoji: "✊",
  },
  {
    "web-scraper-order": "1666028369-2201",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👎 Thumbs Down",
    "people-href": "https://emojipedia.org/thumbs-down/",
    emojiName: "👎 Thumbs Down",
    description: "A thumbs-down gesture indicating disapproval.",
    emoji: "👎",
  },
  {
    "web-scraper-order": "1666028374-2202",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👍 Thumbs Up",
    "people-href": "https://emojipedia.org/thumbs-up/",
    emojiName: "👍 Thumbs Up",
    description: "A thumbs-up gesture indicating approval.",
    emoji: "👍",
  },
  {
    "web-scraper-order": "1666028376-2203",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫵 Index Pointing at the Viewer",
    "people-href": "https://emojipedia.org/index-pointing-at-the-viewer/",
    emojiName: "🫵 Index Pointing at the Viewer",
    description:
      "A hand with the index finger pointing straight forward at the person viewing the emoji. Used to represent the word and concept of 'you,' the second-person singular and plural pronoun.",
    emoji: "🫵",
  },
  {
    "web-scraper-order": "1666028379-2204",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☝️ Index Pointing Up",
    "people-href": "https://emojipedia.org/index-pointing-up/",
    emojiName: "☝️ Index Pointing Up",
    description:
      "A single finger pointing upward, which could be used to represent the number one, or to ask a question.",
    emoji: "☝️",
  },
  {
    "web-scraper-order": "1666028381-2205",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👇 Backhand Index Pointing Down",
    "people-href": "https://emojipedia.org/backhand-index-pointing-down/",
    emojiName: "👇 Backhand Index Pointing Down",
    description: "Index finger pointing downward.",
    emoji: "👇",
  },
  {
    "web-scraper-order": "1666028384-2206",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🖕 Middle Finger",
    "people-href": "https://emojipedia.org/middle-finger/",
    emojiName: "🖕 Middle Finger",
    description:
      "A middle finger emoji, used in some western cultures as a rude or insulting gesture. The back of the hand is shown with the middle finger raised.",
    emoji: "🖕",
  },
  {
    "web-scraper-order": "1666028387-2207",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👆 Backhand Index Pointing Up",
    "people-href": "https://emojipedia.org/backhand-index-pointing-up/",
    emojiName: "👆 Backhand Index Pointing Up",
    description:
      "Index finger pointing upward, showing the back of the hand while doing so.",
    emoji: "👆",
  },
  {
    "web-scraper-order": "1666028389-2208",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👉 Backhand Index Pointing Right",
    "people-href": "https://emojipedia.org/backhand-index-pointing-right/",
    emojiName: "👉 Backhand Index Pointing Right",
    description: "Index finger pointing to the right.",
    emoji: "👉",
  },
  {
    "web-scraper-order": "1666028392-2209",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👈 Backhand Index Pointing Left",
    "people-href": "https://emojipedia.org/backhand-index-pointing-left/",
    emojiName: "👈 Backhand Index Pointing Left",
    description: "Index finger pointing to the left.",
    emoji: "👈",
  },
  {
    "web-scraper-order": "1666028395-2210",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤙 Call Me Hand",
    "people-href": "https://emojipedia.org/call-me-hand/",
    emojiName: "🤙 Call Me Hand",
    description:
      "A hand with thumb and little (pinky) finger extended, making a traditional phone-like shape. May be used in conjunction with a face to suggest “call me” (please).",
    emoji: "🤙",
  },
  {
    "web-scraper-order": "1666028398-2211",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤘 Sign of the Horns",
    "people-href": "https://emojipedia.org/sign-of-the-horns/",
    emojiName: "🤘 Sign of the Horns",
    description:
      'A "rock on" hand gesture raising the pinky and index fingers on one hand, which a variety of other meanings.',
    emoji: "🤘",
  },
  {
    "web-scraper-order": "1666028401-2212",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤟 Love-You Gesture",
    "people-href": "https://emojipedia.org/love-you-gesture/",
    emojiName: "🤟 Love-You Gesture",
    description:
      "The gesture for “I love you” in American Sign Language, shown as a raised pinky (little) finger, index finger, and an extended thumb.",
    emoji: "🤟",
  },
  {
    "web-scraper-order": "1666028404-2213",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫰 Hand with Index Finger and Thumb Crossed",
    "people-href":
      "https://emojipedia.org/hand-with-index-finger-and-thumb-crossed/",
    emojiName: "🫰 Hand with Index Finger and Thumb Crossed",
    description:
      "A hand with the index finger and thumb crossed and the rest of the fingers making a fist. Can be used in various contexts to represent the fingers snapping, love, or money.",
    emoji: "🫰",
  },
  {
    "web-scraper-order": "1666028409-2214",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤞 Crossed Fingers",
    "people-href": "https://emojipedia.org/crossed-fingers/",
    emojiName: "🤞 Crossed Fingers",
    description:
      "A fingers crossed emoji which displays the index (first) finger crossed over the middle (second) finger. Commonly used as a gesture indicating luck, or to show desire of a favorable outcome.",
    emoji: "🤞",
  },
  {
    "web-scraper-order": "1666028411-2215",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✌️ Victory Hand",
    "people-href": "https://emojipedia.org/victory-hand/",
    emojiName: "✌️ Victory Hand",
    description:
      "Most commonly known as a ✌️ Peace Sign, but traditionally called as a Victory Hand. Two fingers held up on one hand making a V sign.",
    emoji: "✌️",
  },
  {
    "web-scraper-order": "1666028415-2216",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤏 Pinching Hand",
    "people-href": "https://emojipedia.org/pinching-hand/",
    emojiName: "🤏 Pinching Hand",
    description:
      "A hand with thumb and index finger in close proximity. Used to suggest that something is small, or to gesture a small amount. Has",
    emoji: "🤏",
  },
  {
    "web-scraper-order": "1666028419-2217",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤌 Pinched Fingers",
    "people-href": "https://emojipedia.org/pinched-fingers/",
    emojiName: "🤌 Pinched Fingers",
    description:
      'An emoji showing the fingers held together in a vertical orientation, often referred to as the Italian hand gesture ma che vuoi, sometimes called the "finger purse." In Italy this gesture tends to be used in disagreement, frustration, or disbelief and can mean “What do you want?” or “What are you saying?” Outside Italy anyone performing a caricature of an Italian person, regardless of context or tone, might use this gesture.',
    emoji: "🤌",
  },
  {
    "web-scraper-order": "1666028423-2218",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👌 OK Hand",
    "people-href": "https://emojipedia.org/ok-hand/",
    emojiName: "👌 OK Hand",
    description:
      "A gesture showing the index finger and thumb touching to make an open circle. Represents “I’m okay” or “yes, that’s correct / good”.",
    emoji: "👌",
  },
  {
    "web-scraper-order": "1666028425-2219",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫴 Palm Up Hand",
    "people-href": "https://emojipedia.org/palm-up-hand/",
    emojiName: "🫴 Palm Up Hand",
    description: "A hand in profile with the palm facing up.",
    emoji: "🫴",
  },
  {
    "web-scraper-order": "1666028428-2220",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫳 Palm Down Hand",
    "people-href": "https://emojipedia.org/palm-down-hand/",
    emojiName: "🫳 Palm Down Hand",
    description: "A hand in profile with the palm facing down.",
    emoji: "🫳",
  },
  {
    "web-scraper-order": "1666028430-2221",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫲 Leftwards Hand",
    "people-href": "https://emojipedia.org/leftwards-hand/",
    emojiName: "🫲 Leftwards Hand",
    description:
      "An open right hand facing left, so as to show the palm of the hand with the thumb on the top and the pinky on the bottom.",
    emoji: "🫲",
  },
  {
    "web-scraper-order": "1666028432-2222",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫱 Rightwards Hand",
    "people-href": "https://emojipedia.org/rightwards-hand/",
    emojiName: "🫱 Rightwards Hand",
    description:
      "An open right hand facing right, so as to show the back of the hand with the thumb on the top and the pinky on the bottom.",
    emoji: "🫱",
  },
  {
    "web-scraper-order": "1666028437-2223",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🖖 Vulcan Salute",
    "people-href": "https://emojipedia.org/vulcan-salute/",
    emojiName: "🖖 Vulcan Salute",
    description:
      "A raised hand, with the fingers separated between the ring finger and the middle finger.",
    emoji: "🖖",
  },
  {
    "web-scraper-order": "1666028440-2224",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✋ Raised Hand",
    "people-href": "https://emojipedia.org/raised-hand/",
    emojiName: "✋ Raised Hand",
    description:
      "A hand held up showing its palm. May be used to mean stop, or as a high-five.",
    emoji: "✋",
  },
  {
    "web-scraper-order": "1666028443-2225",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🖐️ Hand with Fingers Splayed",
    "people-href": "https://emojipedia.org/hand-with-fingers-splayed/",
    emojiName: "🖐️ Hand with Fingers Splayed",
    description:
      "The palm of a hand with the fingers spread apart. Held in a manner that may indicate the number five. Similar to 👋 Waving Hand, but without any motion.",
    emoji: "🖐️",
  },
  {
    "web-scraper-order": "1666028445-2226",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤚 Raised Back of Hand",
    "people-href": "https://emojipedia.org/raised-back-of-hand/",
    emojiName: "🤚 Raised Back of Hand",
    description:
      "A raised hand, showing the reverse side of the palm. May be paired with the forward-facing raised hand emoji.",
    emoji: "🤚",
  },
  {
    "web-scraper-order": "1666028448-2227",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👋 Waving Hand",
    "people-href": "https://emojipedia.org/waving-hand/",
    emojiName: "👋 Waving Hand",
    description:
      "A hand waving most commonly used to say “hello” or “goodbye”.",
    emoji: "👋",
  },
  {
    "web-scraper-order": "1666028451-2228",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💋 Kiss Mark",
    "people-href": "https://emojipedia.org/kiss-mark/",
    emojiName: "💋 Kiss Mark",
    description:
      "The mark left after a firm kiss is placed with bright lipstick. Used in place of ‘xxx’ (kisses), or to send a kiss to someone. More seductive than the kiss emoji.",
    emoji: "💋",
  },
  {
    "web-scraper-order": "1666028453-2229",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😾 Pouting Cat",
    "people-href": "https://emojipedia.org/pouting-cat/",
    emojiName: "😾 Pouting Cat",
    description:
      "A cartoon cat variant of 😡 Pouting Face. Also resembles 😠 Angry Face. Depicted as yellow on major platforms. Sometimes used to represent the internet meme and celebrity Grumpy Cat.",
    emoji: "😾",
  },
  {
    "web-scraper-order": "1666028459-2230",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😿 Crying Cat",
    "people-href": "https://emojipedia.org/crying-cat/",
    emojiName: "😿 Crying Cat",
    description:
      "A cartoon cat variant of 😢 Crying Face. Depicted as yellow on major platforms.",
    emoji: "😿",
  },
  {
    "web-scraper-order": "1666028463-2231",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙀 Weary Cat",
    "people-href": "https://emojipedia.org/weary-cat/",
    emojiName: "🙀 Weary Cat",
    description:
      "A cartoon cat variant of 😩 Weary Face. Its expression more closely resembles 😱 Face Screaming in Fear. Depicted as yellow on major platforms.",
    emoji: "🙀",
  },
  {
    "web-scraper-order": "1666028468-2232",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😽 Kissing Cat",
    "people-href": "https://emojipedia.org/kissing-cat/",
    emojiName: "😽 Kissing Cat",
    description:
      "A cartoon cat variant of 😚 Kissing Face With Closed Eyes. Depicted as yellow on major platforms.",
    emoji: "😽",
  },
  {
    "web-scraper-order": "1666028473-2233",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😼 Cat with Wry Smile",
    "people-href": "https://emojipedia.org/cat-with-wry-smile/",
    emojiName: "😼 Cat with Wry Smile",
    description:
      "A cartoon cat variant of 😏 Smirking Face. Depicted as yellow on major platforms.",
    emoji: "😼",
  },
  {
    "web-scraper-order": "1666028477-2234",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😻 Smiling Cat with Heart-Eyes",
    "people-href": "https://emojipedia.org/smiling-cat-with-heart-eyes/",
    emojiName: "😻 Smiling Cat with Heart-Eyes",
    description:
      "A cartoon cat variant of 😍 Smiling Face With Heart-Eyes. Depicted as yellow on major platforms.",
    emoji: "😻",
  },
  {
    "web-scraper-order": "1666028481-2235",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😹 Cat with Tears of Joy",
    "people-href": "https://emojipedia.org/cat-with-tears-of-joy/",
    emojiName: "😹 Cat with Tears of Joy",
    description:
      "A cartoon cat variant of 😂 Face With Tears of Joy. Depicted as yellow on major platforms.",
    emoji: "😹",
  },
  {
    "web-scraper-order": "1666028486-2236",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😸 Grinning Cat with Smiling Eyes",
    "people-href": "https://emojipedia.org/grinning-cat-with-smiling-eyes/",
    emojiName: "😸 Grinning Cat with Smiling Eyes",
    description:
      "A cartoon cat variant of 😄 Grinning Face With Smiling Eyes. Depicted as yellow on major platforms.",
    emoji: "😸",
  },
  {
    "web-scraper-order": "1666028491-2237",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😺 Grinning Cat",
    "people-href": "https://emojipedia.org/grinning-cat/",
    emojiName: "😺 Grinning Cat",
    description:
      "A cartoon cat variant of 😀 Grinning Face. Depicted as yellow on major platforms.",
    emoji: "😺",
  },
  {
    "web-scraper-order": "1666028494-2238",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤖 Robot",
    "people-href": "https://emojipedia.org/robot/",
    emojiName: "🤖 Robot",
    description:
      "The head of a classic robot. Commonly depicted as a vintage, tin toy robot with circular eyes, a triangular nose, knobs for ears, a light and/or antennae atop its head, and a grill-like mouth similar to a grimace. Colors vary across platform, but its head is metallic on most platforms.",
    emoji: "🤖",
  },
  {
    "web-scraper-order": "1666028498-2239",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👾 Alien Monster",
    "people-href": "https://emojipedia.org/alien-monster/",
    emojiName: "👾 Alien Monster",
    description:
      "A friendly-looking, tentacled space creature with two eyes. Most major platforms style their design after aliens in classic arcade games like Space Invaders, rendering it purple and pixellated, as if in 8-bit graphics.",
    emoji: "👾",
  },
  {
    "web-scraper-order": "1666028502-2240",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👽 Alien",
    "people-href": "https://emojipedia.org/alien/",
    emojiName: "👽 Alien",
    description:
      "A classic alien face. The oval, bare head of a gray or green alien with large black eyes and a slight, friendly smile. Samsung depicts nostrils, Facebook a nose.",
    emoji: "👽",
  },
  {
    "web-scraper-order": "1666028508-2241",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👻 Ghost",
    "people-href": "https://emojipedia.org/ghost/",
    emojiName: "👻 Ghost",
    description:
      "Boo! A white, cartoon ghost making a silly face. Its tongue is stuck out and arms are outstretched, as if trying to scare someone in a friendly way. Several platforms feature one larger, bulging eye.",
    emoji: "👻",
  },
  {
    "web-scraper-order": "1666028513-2242",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👺 Goblin",
    "people-href": "https://emojipedia.org/goblin/",
    emojiName: "👺 Goblin",
    description:
      "A menacing, red mask featuring a grotesquely long nose, angry eyes, and bushy eyebrows and mustache. Depicts a tengu, a proud trickster figure in Japanese folklore.",
    emoji: "👺",
  },
  {
    "web-scraper-order": "1666028516-2243",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👹 Ogre",
    "people-href": "https://emojipedia.org/ogre/",
    emojiName: "👹 Ogre",
    description:
      "A grotesque, red face with horns, wide eyes, a large nose, crooked fangs, and a fringe of shaggy hair. Depicts an oni, a kind of hideous ogre in Japanese folklore.",
    emoji: "👹",
  },
  {
    "web-scraper-order": "1666028521-2244",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤡 Clown Face",
    "people-href": "https://emojipedia.org/clown-face/",
    emojiName: "🤡 Clown Face",
    description:
      "A circus or birthday clown displayed with white face makeup, a red nose, exaggerated eyes and smile, and two tufts of hair (red or blue). Commonly used as comment on TikTok or other social media platforms to indicate that a person is foolish, idiotic and/or selfish.",
    emoji: "🤡",
  },
  {
    "web-scraper-order": "1666028526-2245",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💩 Pile of Poo",
    "people-href": "https://emojipedia.org/pile-of-poo/",
    emojiName: "💩 Pile of Poo",
    description:
      "A swirl of brown poop, shaped like soft-serve ice cream with large, excited eyes and a big, friendly smile.",
    emoji: "💩",
  },
  {
    "web-scraper-order": "1666028530-2246",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☠️ Skull and Crossbones",
    "people-href": "https://emojipedia.org/skull-and-crossbones/",
    emojiName: "☠️ Skull and Crossbones",
    description:
      "A cartoon human skull atop an X-shaped pair of bones, as on a pirate flag or poison symbol. Samsung’s design previously displayed a skull and crossbones on a yellow triangle, indicating a hazardous material.",
    emoji: "☠️",
  },
  {
    "web-scraper-order": "1666028535-2247",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💀 Skull",
    "people-href": "https://emojipedia.org/skull/",
    emojiName: "💀 Skull",
    description:
      "A whitish-gray, cartoon-styled human skull with large, black eye sockets. Commonly expresses figurative death, e.g., dying from extreme laughter, frustration, or affection.",
    emoji: "💀",
  },
  {
    "web-scraper-order": "1666028541-2248",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👿 Angry Face with Horns",
    "people-href": "https://emojipedia.org/angry-face-with-horns/",
    emojiName: "👿 Angry Face with Horns",
    description:
      "A face, usually purple, with two devil horns, frowning mouth and eyes, and eyebrows scrunched downwards in anger. Bears the same expression as 😠 Angry Face and 😡 Pouting Face on most platforms. Google’s design is red and Facebook’s has black horns, green eyes, and clenched teeth.",
    emoji: "👿",
  },
  {
    "web-scraper-order": "1666028558-2249",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😈 Smiling Face with Horns",
    "people-href": "https://emojipedia.org/smiling-face-with-horns/",
    emojiName: "😈 Smiling Face with Horns",
    description:
      "A face, usually purple, with devil horns, a wide grin, and eyes and eyebrows scrunched downward in the same manner as 😠 Angry Face on most platforms. Google’s design is red and Facebook’s has black horns and green eyes.",
    emoji: "😈",
  },
  {
    "web-scraper-order": "1666028562-2250",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤬 Face with Symbols on Mouth",
    "people-href": "https://emojipedia.org/face-with-symbols-on-mouth/",
    emojiName: "🤬 Face with Symbols on Mouth",
    description:
      "An angry-red face with a black bar and white grawlixes covering its mouth, indicating it's swearing or being vulgar. Grawlixes are typographical symbols (e.g., @#$%&!) representing swear words or obscenities. Often used to convey an outburst of anger, frustration, or rage.",
    emoji: "🤬",
  },
  {
    "web-scraper-order": "1666028572-2251",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😠 Angry Face",
    "people-href": "https://emojipedia.org/angry-face/",
    emojiName: "😠 Angry Face",
    description:
      "A yellow face with a frowning mouth and eyes and eyebrows scrunched downward in anger.",
    emoji: "😠",
  },
  {
    "web-scraper-order": "1666028588-2252",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😡 Enraged Face",
    "people-href": "https://emojipedia.org/pouting-face/",
    emojiName: "😡 Enraged Face",
    description:
      "A red face with an angry expression: frowning mouth with eyes and eyebrows scrunched downward. Bears the same expression as 😠 Angry Face on most platforms and may convey more intense degrees of anger, e.g., hate or rage.",
    emoji: "😡",
  },
  {
    "web-scraper-order": "1666028596-2253",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😤 Face with Steam From Nose",
    "people-href": "https://emojipedia.org/face-with-steam-from-nose/",
    emojiName: "😤 Face with Steam From Nose",
    description:
      "A yellow face with closed eyes, furrowed eyebrows, broad frown, and two puffs of steam blowing out of its nose, as if in a huff or fuming.",
    emoji: "😤",
  },
  {
    "web-scraper-order": "1666028601-2254",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥱 Yawning Face",
    "people-href": "https://emojipedia.org/yawning-face/",
    emojiName: "🥱 Yawning Face",
    description:
      "A yellow face with eyes closed and mouth wide open covered by a hand. Captured mid-yawn, this may represent having insufficient sleep, or to imply boredom with a person or topic.",
    emoji: "🥱",
  },
  {
    "web-scraper-order": "1666028609-2255",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😫 Tired Face",
    "people-href": "https://emojipedia.org/tired-face/",
    emojiName: "😫 Tired Face",
    description:
      "A yellow face with scrunched, X-shaped eyes, furrowed eyebrows, and a broad, open frown, as if yawning in exhaustion or groaning in exasperation. Usually shown with upper teeth and sometimes tongue.",
    emoji: "😫",
  },
  {
    "web-scraper-order": "1666028618-2256",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😩 Weary Face",
    "people-href": "https://emojipedia.org/weary-face/",
    emojiName: "😩 Weary Face",
    description:
      "A yellow face with closed eyes, furrowed brows, and a broad, open frown, as if distraught to the point of giving up. Usually shown with upper teeth and sometimes tongue.",
    emoji: "😩",
  },
  {
    "web-scraper-order": "1666028628-2257",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😓 Downcast Face with Sweat",
    "people-href": "https://emojipedia.org/downcast-face-with-sweat/",
    emojiName: "😓 Downcast Face with Sweat",
    description:
      "A yellow face with closed eyes, frown, and a bead of sweat dripping from its forehead. Usually depicted with a single sweat bead on its right side, though Facebook and WhatsApp include the sweat bead on its left side.",
    emoji: "😓",
  },
  {
    "web-scraper-order": "1666028641-2258",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😞 Disappointed Face",
    "people-href": "https://emojipedia.org/disappointed-face/",
    emojiName: "😞 Disappointed Face",
    description:
      "A yellow face with a frown and closed, downcast eyes, as if aching with sorrow or pain. May convey a variety of unhappy emotions, including disappointment, grief, stress, regret, and remorse.",
    emoji: "😞",
  },
  {
    "web-scraper-order": "1666028658-2259",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😣 Persevering Face",
    "people-href": "https://emojipedia.org/persevering-face/",
    emojiName: "😣 Persevering Face",
    description:
      "A yellow face with a slight frown, furrowed eyebrows, and scrunched eyes, as if holding back tears or exerting great effort. May convey various degrees and tones of frustration, sadness, helplessness, and struggle. Facebook’s design features a light-purple forehead.",
    emoji: "😣",
  },
  {
    "web-scraper-order": "1666028667-2260",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😖 Confounded Face",
    "people-href": "https://emojipedia.org/confounded-face/",
    emojiName: "😖 Confounded Face",
    description:
      "A yellow face with scrunched, X-shaped eyes and a crumpled mouth, as if quivering in frustration or holding back tears. May be used to represent being overcome with various emotions, including irritation, frustration, disgust, and sadness, as if to the point of defeat.",
    emoji: "😖",
  },
  {
    "web-scraper-order": "1666028679-2261",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😱 Face Screaming in Fear",
    "people-href": "https://emojipedia.org/face-screaming-in-fear/",
    emojiName: "😱 Face Screaming in Fear",
    description:
      "A yellow face screaming in fear, depicted by wide, white eyes, a long, open mouth, hands pressed on cheeks, and a pale blue forehead, as if it has lost its color. Its expression evokes Edvard Munch’s iconic painting The Scream.",
    emoji: "😱",
  },
  {
    "web-scraper-order": "1666028688-2262",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😭 Loudly Crying Face",
    "people-href": "https://emojipedia.org/loudly-crying-face/",
    emojiName: "😭 Loudly Crying Face",
    description:
      "A yellow face with an open mouth wailing and streams of heavy tears flowing from closed eyes. May convey inconsolable grief but also other intense feelings, such as uncontrollable laughter, pride or overwhelming joy.",
    emoji: "😭",
  },
  {
    "web-scraper-order": "1666028697-2263",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😢 Crying Face",
    "people-href": "https://emojipedia.org/crying-face/",
    emojiName: "😢 Crying Face",
    description:
      "A yellow face with raised eyebrows and a slight frown, shedding a single, blue tear from one eye down its cheek. May convey a moderate degree of sadness or pain, usually less intensely than 😭 Loudly Crying Face.",
    emoji: "😢",
  },
  {
    "web-scraper-order": "1666028716-2264",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😥 Sad but Relieved Face",
    "people-href": "https://emojipedia.org/sad-but-relieved-face/",
    emojiName: "😥 Sad but Relieved Face",
    description:
      "A yellow face with small, open eyes, a slight frown, and furrowed eyebrows, from which a single bead of sweat drips, as if from concern or anxiety. Also known as Disappointed but Relieved Face, suggesting the smiley is upset but is grateful things didn’t turn out worse.",
    emoji: "😥",
  },
  {
    "web-scraper-order": "1666028729-2265",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😰 Anxious Face with Sweat",
    "people-href": "https://emojipedia.org/anxious-face-with-sweat/",
    emojiName: "😰 Anxious Face with Sweat",
    description:
      "A face with open eyes and a small, open frown. Its eyebrows are furrowed, with a single bead of cold sweat dripping down, and its forehead is pale blue, as if experiencing a cold flash. Samsung's design shows upper teeth and tongue.",
    emoji: "😰",
  },
  {
    "web-scraper-order": "1666028736-2266",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😨 Fearful Face",
    "people-href": "https://emojipedia.org/fearful-face/",
    emojiName: "😨 Fearful Face",
    description:
      "A face with small, open eyes, open frown, raised eyebrows, and a pale blue forehead, as if experiencing a cold flash. Samsung’s design shows upper teeth and tongue.",
    emoji: "😨",
  },
  {
    "web-scraper-order": "1666028744-2267",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😧 Anguished Face",
    "people-href": "https://emojipedia.org/anguished-face/",
    emojiName: "😧 Anguished Face",
    description:
      "A yellow face with small, open eyes, open frown, and raised eyebrows. Samsung’s design shows upper teeth and tongue. Meaning widely varies, but may convey alarm, confusion, or sadness, as if gasping in shock or concern.",
    emoji: "😧",
  },
  {
    "web-scraper-order": "1666028761-2268",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😦 Frowning Face with Open Mouth",
    "people-href": "https://emojipedia.org/frowning-face-with-open-mouth/",
    emojiName: "😦 Frowning Face with Open Mouth",
    description:
      "A yellow face with small, open eyes and an open frown. Samsung’s design shows upper teeth and tongue. Meaning widely varies, but may convey mild sadness, disappointment, concern, and amazement.",
    emoji: "😦",
  },
  {
    "web-scraper-order": "1666028765-2269",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥹 Face Holding Back Tears",
    "people-href": "https://emojipedia.org/face-holding-back-tears/",
    emojiName: "🥹 Face Holding Back Tears",
    description:
      "A yellow face with tears welling up at the bottom of its two large eyes.",
    emoji: "🥹",
  },
  {
    "web-scraper-order": "1666028782-2270",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥺 Pleading Face",
    "people-href": "https://emojipedia.org/pleading-face/",
    emojiName: "🥺 Pleading Face",
    description:
      "A yellow face with furrowed eyebrows, a small frown, and large, “puppy dog” eyes, as if begging or pleading. May also represent adoration or feeling touched by a loving gesture.",
    emoji: "🥺",
  },
  {
    "web-scraper-order": "1666028794-2271",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😳 Flushed Face",
    "people-href": "https://emojipedia.org/flushed-face/",
    emojiName: "😳 Flushed Face",
    description:
      "A yellow face with raised eyebrows, a small, closed mouth, wide, white eyes staring straight ahead, and blushing cheeks. Intended to depict such feelings as embarrassment, but meaning very widely varies. Other senses include flattery, surprise, disbelief, admiration, affection, and excitement.",
    emoji: "😳",
  },
  {
    "web-scraper-order": "1666028799-2272",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😲 Astonished Face",
    "people-href": "https://emojipedia.org/astonished-face/",
    emojiName: "😲 Astonished Face",
    description:
      "A yellow face with open eyes, raised eyebrows, and an open mouth, as if gasping in shock or surprise. Often depicted showing its upper teeth. May convey a wide range of emotions, including awe, amazement, admiration, disbelief, excitement, or concern.",
    emoji: "😲",
  },
  {
    "web-scraper-order": "1666028802-2273",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😯 Hushed Face",
    "people-href": "https://emojipedia.org/hushed-face/",
    emojiName: "😯 Hushed Face",
    description:
      "A yellow face with small, open eyes, raised eyebrows, and a small, open mouth, as if it has been hushed by concern or correction. Meaning widely varies, but its expression is commonly taken as surprise, embarrassment, or mild excitement.",
    emoji: "😯",
  },
  {
    "web-scraper-order": "1666028807-2274",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😮 Face with Open Mouth",
    "people-href": "https://emojipedia.org/face-with-open-mouth/",
    emojiName: "😮 Face with Open Mouth",
    description:
      "A yellow face with small, open eyes and a large, round mouth, slack with surprise or shock, as if saying Wow! or Oh my! May convey such feelings as awe or disbelief, often milder or more ironic in tone than 😱 Face Screaming in Fear.",
    emoji: "😮",
  },
  {
    "web-scraper-order": "1666028812-2275",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☹️ Frowning Face",
    "people-href": "https://emojipedia.org/frowning-face/",
    emojiName: "☹️ Frowning Face",
    description:
      "A classic sad face. A yellow face with simple, open eyes and wide, steep frown. May convey such feelings as moderate concern or disappointment and affectionate sadness, as when missing a loved one. Its sentiment is usually more intense than 🙁 Slightly Frowning Face, which has a smaller frown.",
    emoji: "☹️",
  },
  {
    "web-scraper-order": "1666028816-2276",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙁 Slightly Frowning Face",
    "people-href": "https://emojipedia.org/slightly-frowning-face/",
    emojiName: "🙁 Slightly Frowning Face",
    description:
      "A yellow face with simple, open eyes and a slight frown. Often conveys a mild degree of concern, disappointment, or sadness, but usually less intensely than ☹️ Frowning Face.",
    emoji: "🙁",
  },
  {
    "web-scraper-order": "1666028821-2277",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😟 Worried Face",
    "people-href": "https://emojipedia.org/worried-face/",
    emojiName: "😟 Worried Face",
    description:
      "A yellow face with open eyes, raised or furrowed eyebrows, and a broad frown. May convey a variety of moderately sad or tense emotions, including concern, anxiety, alarm, disappointment, and unhappiness.",
    emoji: "😟",
  },
  {
    "web-scraper-order": "1666028824-2278",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫤 Face with Diagonal Mouth",
    "people-href": "https://emojipedia.org/face-with-diagonal-mouth/",
    emojiName: "🫤 Face with Diagonal Mouth",
    description:
      "A yellow face with a closed slanted mouth. Can be used to express skepticism, confusion, or frustration.",
    emoji: "🫤",
  },
  {
    "web-scraper-order": "1666028839-2279",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😕 Confused Face",
    "people-href": "https://emojipedia.org/confused-face/",
    emojiName: "😕 Confused Face",
    description:
      "A yellow face with open eyes and a skewed frown, as if scrunching its cheeks or chewing its lips. A look of feeling unsure.",
    emoji: "😕",
  },
  {
    "web-scraper-order": "1666028844-2280",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧐 Face with Monocle",
    "people-href": "https://emojipedia.org/face-with-monocle/",
    emojiName: "🧐 Face with Monocle",
    description:
      "A yellow face with furrowed eyebrows wearing a monocle. Usually depicted with a small, intent frown and head slightly upturned, as if in careful inspection.",
    emoji: "🧐",
  },
  {
    "web-scraper-order": "1666028848-2281",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤓 Nerd Face",
    "people-href": "https://emojipedia.org/nerd-face/",
    emojiName: "🤓 Nerd Face",
    description:
      "A smiling yellow face with glasses, often with teeth showing, originally buck teeth on most platforms.",
    emoji: "🤓",
  },
  {
    "web-scraper-order": "1666028858-2282",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😎 Smiling Face with Sunglasses",
    "people-href": "https://emojipedia.org/smiling-face-with-sunglasses/",
    emojiName: "😎 Smiling Face with Sunglasses",
    description:
      "A yellow face with a broad, closed smile wearing black sunglasses, as if a pair of classic Wayfarers. Often used to convey the slang sense of cool. May also express a confident, carefree attitude or that something is excellent.",
    emoji: "😎",
  },
  {
    "web-scraper-order": "1666028863-2283",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥸 Disguised Face",
    "people-href": "https://emojipedia.org/disguised-face/",
    emojiName: "🥸 Disguised Face",
    description:
      "A yellow face with big glasses, a large nose, thick eyebrows, and a mustache. Used to represent someone in disguise.",
    emoji: "🥸",
  },
  {
    "web-scraper-order": "1666028868-2284",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥳 Partying Face",
    "people-href": "https://emojipedia.org/partying-face/",
    emojiName: "🥳 Partying Face",
    description:
      "A yellow face with a party hat blowing a party horn as confetti floats around its head. Used for celebrating joyous occasions (such as New Year's Eve or World Emoji Day) and enjoying good times more generally.",
    emoji: "🥳",
  },
  {
    "web-scraper-order": "1666028874-2285",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤠 Cowboy Hat Face",
    "people-href": "https://emojipedia.org/cowboy-hat-face/",
    emojiName: "🤠 Cowboy Hat Face",
    description:
      "Yee-haw! A yellow smiley wearing a wide-brimmed, brown-leather cowboy hat. Its smile varies across platforms. May convey a sense of exuberance, whimsy, confidence, adventure, or other sentiments.",
    emoji: "🤠",
  },
  {
    "web-scraper-order": "1666028883-2286",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤯 Exploding Head",
    "people-href": "https://emojipedia.org/exploding-head/",
    emojiName: "🤯 Exploding Head",
    description:
      "A yellow face with an open mouth, the top of its head exploding in the shape of a brain-like mushroom cloud. A visual form of the expression mind blown, it may represent such emotions as shock, awe, amazement, and disbelief.",
    emoji: "🤯",
  },
  {
    "web-scraper-order": "1666028893-2287",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😵‍💫 Face with Spiral Eyes",
    "people-href": "https://emojipedia.org/face-with-spiral-eyes/",
    emojiName: "😵‍💫 Face with Spiral Eyes",
    description:
      "A face showing a spiral eyes, commonly used to indicate dizziness, but may also represent hypnosis or other forms of disorientation.",
    emoji: "😵‍💫",
  },
  {
    "web-scraper-order": "1666028898-2288",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😵 Face with Crossed-Out Eyes",
    "people-href": "https://emojipedia.org/dizzy-face/",
    emojiName: "😵 Face with Crossed-Out Eyes",
    description:
      "A yellow face with X’s for eyes and a round, open mouth. Often depicted with raised or furrowed eyebrows. Facebook’s design features a purple forehead. Previously displayed with spiral eyes on some platforms.",
    emoji: "😵",
  },
  {
    "web-scraper-order": "1666028904-2289",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥴 Woozy Face",
    "people-href": "https://emojipedia.org/woozy-face/",
    emojiName: "🥴 Woozy Face",
    description:
      "A yellow face with a crumpled mouth and a cockeyed expression, as if tired and emotional from inebriation or smitten with love. Depicted with raised or furrowed eyebrows and at least one eye half-open. WhatsApp's design features a tongue hanging out.",
    emoji: "🥴",
  },
  {
    "web-scraper-order": "1666028908-2290",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥶 Cold Face",
    "people-href": "https://emojipedia.org/cold-face/",
    emojiName: "🥶 Cold Face",
    description:
      "An icy-blue face with gritted teeth usually depicted with icicles clinging to its cheeks or jaw, as if frozen from extreme cold. May also represent unfriendliness (slang, cold) or excellence (slang, cool or chill).",
    emoji: "🥶",
  },
  {
    "web-scraper-order": "1666028914-2291",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥵 Hot Face",
    "people-href": "https://emojipedia.org/hot-face/",
    emojiName: "🥵 Hot Face",
    description:
      "A reddish-orange face with furrowed eyebrows, tongue stuck out, and beads of sweat, as if overheated from high temperatures. Number and position of sweat droplets vary by platforms. May also represent physical attractiveness (slang, hot).",
    emoji: "🥵",
  },
  {
    "web-scraper-order": "1666028919-2292",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤧 Sneezing Face",
    "people-href": "https://emojipedia.org/sneezing-face/",
    emojiName: "🤧 Sneezing Face",
    description:
      "A yellow face with scrunched, X-shaped eyes sneezing or blowing its nose into a white tissue, as if from a cold or allergies. Often depicted with a crumpled-looking mouth.",
    emoji: "🤧",
  },
  {
    "web-scraper-order": "1666028922-2293",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤮 Face Vomiting",
    "people-href": "https://emojipedia.org/face-vomiting/",
    emojiName: "🤮 Face Vomiting",
    description:
      "A yellow face with scrunched, X-shaped eyes spewing bright-green vomit. May represent physical illness or disgust, more intensely so than 🤢 Nauseated Face.",
    emoji: "🤮",
  },
  {
    "web-scraper-order": "1666028927-2294",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤢 Nauseated Face",
    "people-href": "https://emojipedia.org/nauseated-face/",
    emojiName: "🤢 Nauseated Face",
    description:
      "A sickly-green face with concerned eyes and puffed, often red cheeks, as if holding back vomit. May represent physical illness or general disgust. Not to be confused with 🤮 Face Vomiting.",
    emoji: "🤢",
  },
  {
    "web-scraper-order": "1666028932-2295",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤕 Face with Head-Bandage",
    "people-href": "https://emojipedia.org/face-with-head-bandage/",
    emojiName: "🤕 Face with Head-Bandage",
    description:
      "A yellow face with a half-frown and white bandage wrapped around its head, often depicted partially over one eye. May represent physical injury or pain but also emotional hurting, sometimes for ironic effect.",
    emoji: "🤕",
  },
  {
    "web-scraper-order": "1666028937-2296",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤒 Face with Thermometer",
    "people-href": "https://emojipedia.org/face-with-thermometer/",
    emojiName: "🤒 Face with Thermometer",
    description:
      "A yellow face with raised or furrowed eyebrows and a thermometer in its mouth. Often depicted with red cheeks, as if feverish. May be used to represent a hospital patient or person with a cold or flu.",
    emoji: "🤒",
  },
  {
    "web-scraper-order": "1666028942-2297",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😷 Face with Medical Mask",
    "people-href": "https://emojipedia.org/face-with-medical-mask/",
    emojiName: "😷 Face with Medical Mask",
    description:
      "A yellow face wearing a white surgical mask, as used by health workers in hospitals as well as the general public during a pandemic. May be worn to avoid sickness or spreading airborne diseases.",
    emoji: "😷",
  },
  {
    "web-scraper-order": "1666028951-2298",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😴 Sleeping Face",
    "people-href": "https://emojipedia.org/sleeping-face/",
    emojiName: "😴 Sleeping Face",
    description:
      "A yellow face with eyes closed and mouth letting out three, cartoon-styled Zzz’s overhead to indicate it's sound asleep. The Zzz’s appear blue or purple across most platforms. May also represent boredom (slang, snooze).",
    emoji: "😴",
  },
  {
    "web-scraper-order": "1666028961-2299",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤤 Drooling Face",
    "people-href": "https://emojipedia.org/drooling-face/",
    emojiName: "🤤 Drooling Face",
    description:
      "A yellow face, usually shown with closed eyes and raised eyebrows, with saliva drooling from one corner of its mouth. Often used to show desire for a person (sexy, attractive) or object (e.g., delicious food). May also represent someone is tired or sleeping.",
    emoji: "🤤",
  },
  {
    "web-scraper-order": "1666028970-2300",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😪 Sleepy Face",
    "people-href": "https://emojipedia.org/sleepy-face/",
    emojiName: "😪 Sleepy Face",
    description:
      "A yellow face with closed eyes, mouth slightly open, and a blue snot bubble coming from its nose. Snot bubbles indicate a character is tired or sleeping in anime or manga. Not to be confused with 😴 Sleeping Face",
    emoji: "😪",
  },
  {
    "web-scraper-order": "1666028982-2301",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😔 Pensive Face",
    "people-href": "https://emojipedia.org/pensive-face/",
    emojiName: "😔 Pensive Face",
    description:
      "A pensive, remorseful face. Saddened by life. Quietly considering where things all went wrong. Depicted as a yellow face with sad, closed eyes, furrowed eyebrows, and a slight, flat mouth.",
    emoji: "😔",
  },
  {
    "web-scraper-order": "1666028995-2302",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😌 Relieved Face",
    "people-href": "https://emojipedia.org/relieved-face/",
    emojiName: "😌 Relieved Face",
    description:
      "A yellow face with soft, closed eyes, raised eyebrows, and a slight smile. Facebook’s design features a slightly open mouth, as if sighing.",
    emoji: "😌",
  },
  {
    "web-scraper-order": "1666029000-2303",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤥 Lying Face",
    "people-href": "https://emojipedia.org/lying-face/",
    emojiName: "🤥 Lying Face",
    description:
      "A yellow face with raised eyebrows, enlarged eyes, slight frown, and long nose, indicating it’s telling a lie in the manner of Pinocchio. Like that character, Facebook's design features a wooden nose.",
    emoji: "🤥",
  },
  {
    "web-scraper-order": "1666029007-2304",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😮‍💨 Face Exhaling",
    "people-href": "https://emojipedia.org/face-exhaling/",
    emojiName: "😮‍💨 Face Exhaling",
    description:
      "A face showing a visible breath of air being dispelled. Used to represent relief, exhaustion, or as a sigh of disappointment or displeasure.",
    emoji: "😮‍💨",
  },
  {
    "web-scraper-order": "1666029021-2305",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😬 Grimacing Face",
    "people-href": "https://emojipedia.org/grimacing-face/",
    emojiName: "😬 Grimacing Face",
    description:
      "A yellow face with simple open eyes showing clenched teeth. May represent a range of negative or tense emotions, especially nervousness, embarrassment, or awkwardness (e.g., Eek!).",
    emoji: "😬",
  },
  {
    "web-scraper-order": "1666029036-2306",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙄 Face with Rolling Eyes",
    "people-href": "https://emojipedia.org/face-with-rolling-eyes/",
    emojiName: "🙄 Face with Rolling Eyes",
    description:
      "A yellow face with a small, closed mouth, flat or frowning, rolling its large, white eyes upwards. As with the gesture of an eye-roll, commonly conveys moderate disdain, disapproval, frustration, or boredom. Tone varies, including playful, sassy, resentful, and sarcastic, as if saying Yeah, whatever.",
    emoji: "🙄",
  },
  {
    "web-scraper-order": "1666029050-2307",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😒 Unamused Face",
    "people-href": "https://emojipedia.org/unamused-face/",
    emojiName: "😒 Unamused Face",
    description:
      "A yellow face with slightly raised eyebrows, a frown, and eyes looking to the side. May convey a variety of negative emotions, including irritation, displeasure, grumpiness, and skepticism, as if giving the side-eye.",
    emoji: "😒",
  },
  {
    "web-scraper-order": "1666029060-2308",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😏 Smirking Face",
    "people-href": "https://emojipedia.org/smirking-face/",
    emojiName: "😏 Smirking Face",
    description:
      "A yellow face with a sly, smug, mischievous, or suggestive facial expression. It features a half-smile, raised eyebrows, and eyes looking to the side. Often used to convey flirtation or sexual innuendo.",
    emoji: "😏",
  },
  {
    "web-scraper-order": "1666029067-2309",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😶‍🌫️ Face in Clouds",
    "people-href": "https://emojipedia.org/face-in-clouds/",
    emojiName: "😶‍🌫️ Face in Clouds",
    description:
      "A face that appears surrounded by clouds or a haze of smoke. Ambiguous in appearance, this may represent a foggy state of mind, confusion, or even a sense of calm bliss.",
    emoji: "😶‍🌫️",
  },
  {
    "web-scraper-order": "1666029069-2310",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫥 Dotted Line Face",
    "people-href": "https://emojipedia.org/dotted-line-face/",
    emojiName: "🫥 Dotted Line Face",
    description: "A muted yellow neutral face with a dotted or dashed outline.",
    emoji: "🫥",
  },
  {
    "web-scraper-order": "1666029084-2311",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😶 Face Without Mouth",
    "people-href": "https://emojipedia.org/face-without-mouth/",
    emojiName: "😶 Face Without Mouth",
    description:
      "A yellow face with simple, open eyes and no mouth, as if at a loss for words. Meaning widely varies, but commonly conveys speechlessness, humility, and silence. May also convey moderately negative emotions, such as disappointment, frustration, or sadness.",
    emoji: "😶",
  },
  {
    "web-scraper-order": "1666029095-2312",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😑 Expressionless Face",
    "people-href": "https://emojipedia.org/expressionless-face/",
    emojiName: "😑 Expressionless Face",
    description:
      "A yellow face with flat, closed eyes and mouth. May convey a sense of frustration or annoyance more intense than suggested by 😐 Neutral Face, as if taking a moment to collect itself.",
    emoji: "😑",
  },
  {
    "web-scraper-order": "1666029109-2313",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😐 Neutral Face",
    "people-href": "https://emojipedia.org/neutral-face/",
    emojiName: "😐 Neutral Face",
    description:
      "A yellow face with simple, open eyes and a flat, closed mouth. Intended to depict a neutral sentiment but often used to convey mild irritation and concern or a deadpan sense of humor.",
    emoji: "😐",
  },
  {
    "web-scraper-order": "1666029113-2314",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤨 Face with Raised Eyebrow",
    "people-href": "https://emojipedia.org/face-with-raised-eyebrow/",
    emojiName: "🤨 Face with Raised Eyebrow",
    description:
      "A yellow face with a flat, neutral mouth and furrowed eyebrows, its left raised higher than its right. Conveys a wide variety of sentiments, including suspicion, skepticism, concern, consideration, disbelief, and disapproval.",
    emoji: "🤨",
  },
  {
    "web-scraper-order": "1666029120-2315",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤐 Zipper-Mouth Face",
    "people-href": "https://emojipedia.org/zipper-mouth-face/",
    emojiName: "🤐 Zipper-Mouth Face",
    description:
      "A yellow face with simple, open eyes and a closed zipper for a mouth. Meaning widely varies, but commonly conveys a secret or that someone will keep one (e.g., My lips are sealed). May also be used to tell someone to stop talking (e.g., Zip it! or I’ll shut up now).",
    emoji: "🤐",
  },
  {
    "web-scraper-order": "1666029122-2316",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫡 Saluting Face",
    "people-href": "https://emojipedia.org/saluting-face/",
    emojiName: "🫡 Saluting Face",
    description:
      "A yellow face with its right hand saluting. Used as a sign of respect.",
    emoji: "🫡",
  },
  {
    "web-scraper-order": "1666029132-2317",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤔 Thinking Face",
    "people-href": "https://emojipedia.org/thinking-face/",
    emojiName: "🤔 Thinking Face",
    description:
      "A yellow face with furrowed eyebrows looking upwards with thumb and index finger resting on its chin. Intended to show a person pondering or deep in thought. Often used to question or scorn something or someone, as if saying Hmm, I don't know about that. Tone varies, including earnest, playful, puzzled, skeptical, and mocking.",
    emoji: "🤔",
  },
  {
    "web-scraper-order": "1666029146-2318",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤫 Shushing Face",
    "people-href": "https://emojipedia.org/shushing-face/",
    emojiName: "🤫 Shushing Face",
    description:
      "A yellow face placing an index finger over pursed lips, as if issuing Shh! or Shush! for silence. Some platforms feature raised eyebrows. Apple’s design suggests the face is tilting back slightly.",
    emoji: "🤫",
  },
  {
    "web-scraper-order": "1666029148-2319",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫣 Face with Peeking Eye",
    "people-href": "https://emojipedia.org/face-with-peeking-eye/",
    emojiName: "🫣 Face with Peeking Eye",
    description:
      "A yellow face with its hands over its eyes and raised eyebrows. One wide eye is peeking through the fingers.",
    emoji: "🫣",
  },
  {
    "web-scraper-order": "1666029150-2320",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫢 Face with Open Eyes and Hand Over Mouth",
    "people-href":
      "https://emojipedia.org/face-with-open-eyes-and-hand-over-mouth/",
    emojiName: "🫢 Face with Open Eyes and Hand Over Mouth",
    description:
      "A yellow face with open (non-smiling) eyes and a hand over the mouth, used to convey shock or surprise.",
    emoji: "🫢",
  },
  {
    "web-scraper-order": "1666029163-2321",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤭 Face with Hand Over Mouth",
    "people-href": "https://emojipedia.org/face-with-hand-over-mouth/",
    emojiName: "🤭 Face with Hand Over Mouth",
    description:
      "A yellow face with a hand covering its mouth. Displays most often with smiling eyes and/or blushing cheeks, suggesting coy laughter or embarrassment, as if cheekily saying Oops!",
    emoji: "🤭",
  },
  {
    "web-scraper-order": "1666029178-2322",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤗 Smiling Face with Open Hands",
    "people-href": "https://emojipedia.org/hugging-face/",
    emojiName: "🤗 Smiling Face with Open Hands",
    description:
      "A yellow face smiling with open hands, as if giving a hug. May be used to offer thanks and support, show love and care, or express warm, positive feelings more generally.",
    emoji: "🤗",
  },
  {
    "web-scraper-order": "1666029192-2323",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤑 Money-Mouth Face",
    "people-href": "https://emojipedia.org/money-mouth-face/",
    emojiName: "🤑 Money-Mouth Face",
    description:
      "A yellow face with raised eyebrows, dollar signs for eyes, and an open smile sticking out a tongue styled after a green, dollar banknote. Some platforms depict the dollar-sign eyes in green circles.",
    emoji: "🤑",
  },
  {
    "web-scraper-order": "1666029202-2324",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😝 Squinting Face with Tongue",
    "people-href": "https://emojipedia.org/squinting-face-with-tongue/",
    emojiName: "😝 Squinting Face with Tongue",
    description:
      "A yellow face with scrunched, X-shaped eyes and a big grin, sticking out its tongue. Often conveys a sense of fun, excitement, playfulness, hilarity, and happiness, as if saying Squee! or Awesome!",
    emoji: "😝",
  },
  {
    "web-scraper-order": "1666029210-2325",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤪 Zany Face",
    "people-href": "https://emojipedia.org/zany-face/",
    emojiName: "🤪 Zany Face",
    description:
      "A yellow face with its head tilted, its tongue hanging out of a big grin, and wide eyes in a wild, cockeyed expression. Generally used to express silliness.",
    emoji: "🤪",
  },
  {
    "web-scraper-order": "1666029217-2326",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😜 Winking Face with Tongue",
    "people-href": "https://emojipedia.org/winking-face-with-tongue/",
    emojiName: "😜 Winking Face with Tongue",
    description:
      "A yellow face sticking out its tongue and making a zany wink, usually shown with its right eye closed and left wide open. Often conveys a sense of fun, excitement, wackiness, buffoonery, or joking.",
    emoji: "😜",
  },
  {
    "web-scraper-order": "1666029226-2327",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😛 Face with Tongue",
    "people-href": "https://emojipedia.org/face-with-tongue/",
    emojiName: "😛 Face with Tongue",
    description:
      "A yellow face with small, open eyes and a big grin, playfully sticking out its tongue. Can variously convey a sense of fun, excitement, silliness, cuteness, happiness, or jesting, as if saying Just kidding!",
    emoji: "😛",
  },
  {
    "web-scraper-order": "1666029233-2328",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😋 Face Savoring Food",
    "people-href": "https://emojipedia.org/face-savoring-food/",
    emojiName: "😋 Face Savoring Food",
    description:
      "A yellow face with smiling eyes and a broad, closed smile with its tongue sticking out of one corner, as if licking its lips in appetite or contentment. Widely used to convey that a food item is delicious. May also express that a person is attractive.",
    emoji: "😋",
  },
  {
    "web-scraper-order": "1666029237-2329",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥲 Smiling Face with Tear",
    "people-href": "https://emojipedia.org/smiling-face-with-tear/",
    emojiName: "🥲 Smiling Face with Tear",
    description:
      "A yellow face with open eyes, a thin closed-mouth smile, and a single tear falling from one of its eyes. Can be used to express a wide range of emotions and expressions including gratitude, tender happiness, an attempt to look happy when actually sad, or smiling through pain. Can also be a response to something that is bittersweet.",
    emoji: "🥲",
  },
  {
    "web-scraper-order": "1666029242-2330",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😙 Kissing Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/kissing-face-with-smiling-eyes/",
    emojiName: "😙 Kissing Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and puckered lips giving a kiss. Commonly conveys sentiments of love and affection.",
    emoji: "😙",
  },
  {
    "web-scraper-order": "1666029250-2331",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😚 Kissing Face with Closed Eyes",
    "people-href": "https://emojipedia.org/kissing-face-with-closed-eyes/",
    emojiName: "😚 Kissing Face with Closed Eyes",
    description:
      "A yellow face with smiling eyes, rosy cheeks, and puckered lips giving a kiss. Commonly conveys sentiments of romantic love and affection. Several platforms, including Apple, feature the same eyes and cheeks as their ☺️ Smiling Face.",
    emoji: "😚",
  },
  {
    "web-scraper-order": "1666029255-2332",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☺️ Smiling Face",
    "people-href": "https://emojipedia.org/smiling-face/",
    emojiName: "☺️ Smiling Face",
    description:
      "A classic smiley. A yellow face with a modest smile, rosy cheeks, and soft, closed eyes. Many platforms, including Apple, feature relaxed eyebrows. Conveys a wide range of warm, positive feelings, including love, happiness, and gratitude.",
    emoji: "☺️",
  },
  {
    "web-scraper-order": "1666029260-2333",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😗 Kissing Face",
    "people-href": "https://emojipedia.org/kissing-face/",
    emojiName: "😗 Kissing Face",
    description:
      "A yellow face with simple, open eyes and puckered lips giving a kiss. Commonly conveys sentiments of love and affection.",
    emoji: "😗",
  },
  {
    "web-scraper-order": "1666029268-2334",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😘 Face Blowing a Kiss",
    "people-href": "https://emojipedia.org/face-blowing-a-kiss/",
    emojiName: "😘 Face Blowing a Kiss",
    description:
      "A yellow face winking with puckered lips blowing a kiss, depicted as a small, red heart. May represent a kiss goodbye or good night and convey feelings of love and affection more generally.",
    emoji: "😘",
  },
  {
    "web-scraper-order": "1666029273-2335",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤩 Star-Struck",
    "people-href": "https://emojipedia.org/star-struck/",
    emojiName: "🤩 Star-Struck",
    description:
      "A yellow face with a broad, open smile, showing upper teeth on most platforms, with stars for eyes, as if seeing a beloved celebrity. Color of stars widely varies by platform, though commonly gold or red. May express that someone or something is amazing, fascinating, impressive, or exciting.",
    emoji: "🤩",
  },
  {
    "web-scraper-order": "1666029281-2336",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😍 Smiling Face with Heart-Eyes",
    "people-href": "https://emojipedia.org/smiling-face-with-heart-eyes/",
    emojiName: "😍 Smiling Face with Heart-Eyes",
    description:
      "A yellow face with an open smile, sometimes showing teeth, and red, cartoon-styled hearts for eyes. Often conveys enthusiastic feelings of love, infatuation, and adoration, e.g., I love/am in love with this person or thing.",
    emoji: "😍",
  },
  {
    "web-scraper-order": "1666029290-2337",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥰 Smiling Face with Hearts",
    "people-href": "https://emojipedia.org/smiling-face-with-hearts/",
    emojiName: "🥰 Smiling Face with Hearts",
    description:
      "A yellow face with smiling eyes, a closed smile, rosy cheeks, and several hearts floating around its head. Expresses a range of happy, affectionate feelings, especially being in love. The placement of the hearts varies slightly by platform.",
    emoji: "🥰",
  },
  {
    "web-scraper-order": "1666029305-2338",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😇 Smiling Face with Halo",
    "people-href": "https://emojipedia.org/smiling-face-with-halo/",
    emojiName: "😇 Smiling Face with Halo",
    description:
      "A yellow face with smiling eyes, closed smile, and halo, usually blue, overhead. Often represents angels, prayers, and blessings. May also convey angelic behavior, e.g., doing good deeds. See also 👼 Baby Angel.",
    emoji: "😇",
  },
  {
    "web-scraper-order": "1666029319-2339",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😊 Smiling Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/smiling-face-with-smiling-eyes/",
    emojiName: "😊 Smiling Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and a broad, closed smile turning up to rosy cheeks. Often expresses genuine happiness and warm, positive feelings.",
    emoji: "😊",
  },
  {
    "web-scraper-order": "1666029330-2340",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😉 Winking Face",
    "people-href": "https://emojipedia.org/winking-face/",
    emojiName: "😉 Winking Face",
    description:
      "A yellow face with a slight smile or open mouth shown winking, usually its left eye. May signal a joke, flirtation, hidden meaning, or general positivity. Tone varies, including playful, affectionate, suggestive, or ironic.",
    emoji: "😉",
  },
  {
    "web-scraper-order": "1666029333-2341",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫠 Melting Face",
    "people-href": "https://emojipedia.org/melting-face/",
    emojiName: "🫠 Melting Face",
    description: "A yellow smiley face melting into a puddle.",
    emoji: "🫠",
  },
  {
    "web-scraper-order": "1666029341-2342",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙃 Upside-Down Face",
    "people-href": "https://emojipedia.org/upside-down-face/",
    emojiName: "🙃 Upside-Down Face",
    description:
      "A classic smiley, turned upside down. Implemented as a flipped version of 🙂 Slightly Smiling Face on most platforms.",
    emoji: "🙃",
  },
  {
    "web-scraper-order": "1666029356-2343",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙂 Slightly Smiling Face",
    "people-href": "https://emojipedia.org/slightly-smiling-face/",
    emojiName: "🙂 Slightly Smiling Face",
    description:
      "A yellow face with simple, open eyes and a thin, closed smile. Conveys a wide range of positive, happy, and friendly sentiments. Its tone can also be patronizing, passive-aggressive, or ironic, as if saying This is fine when it’s really not.",
    emoji: "🙂",
  },
  {
    "web-scraper-order": "1666029366-2344",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😂 Face with Tears of Joy",
    "people-href": "https://emojipedia.org/face-with-tears-of-joy/",
    emojiName: "😂 Face with Tears of Joy",
    description:
      "A yellow face with a big grin, uplifted eyebrows, and smiling eyes, each shedding a tear from laughing so hard. Widely used to show something is funny or pleasing.",
    emoji: "😂",
  },
  {
    "web-scraper-order": "1666029372-2345",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤣 Rolling on the Floor Laughing",
    "people-href": "https://emojipedia.org/rolling-on-the-floor-laughing/",
    emojiName: "🤣 Rolling on the Floor Laughing",
    description:
      "A yellow face with a big grin and scrunched, X-shaped eyes, tilted on its side as if rolling on the floor laughing (the internet acronym ROFL). Sheds two tears and tilts right on most platforms. Often conveys hysterical laughter more intense than 😂 Face With Tears of Joy.",
    emoji: "🤣",
  },
  {
    "web-scraper-order": "1666029381-2346",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😅 Grinning Face with Sweat",
    "people-href": "https://emojipedia.org/grinning-face-with-sweat/",
    emojiName: "😅 Grinning Face with Sweat",
    description:
      "Has the same grin and eyes as 😄 Grinning Face With Smiling Eyes but with a single, blue bead of sweat, usually over its left eye. Intended to depict nerves or discomfort but commonly used to express a close call, as if saying Whew! and wiping sweat from the forehead.",
    emoji: "😅",
  },
  {
    "web-scraper-order": "1666029395-2347",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😆 Grinning Squinting Face",
    "people-href": "https://emojipedia.org/grinning-squinting-face/",
    emojiName: "😆 Grinning Squinting Face",
    description:
      "A yellow face with a broad, open smile and scrunched, X-shaped eyes. Often conveys excitement or hearty laughter.",
    emoji: "😆",
  },
  {
    "web-scraper-order": "1666029411-2348",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😁 Beaming Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/beaming-face-with-smiling-eyes/",
    emojiName: "😁 Beaming Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and full-toothed grin, as if saying Cheese! for the camera. Teeth may be smoothed-over or crosshatched. Often expresses a radiant, gratified happiness. Tone varies, including warm, silly, amused, or proud.",
    emoji: "😁",
  },
  {
    "web-scraper-order": "1666029422-2349",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😄 Grinning Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/grinning-face-with-smiling-eyes/",
    emojiName: "😄 Grinning Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general happiness and good-natured amusement.",
    emoji: "😄",
  },
  {
    "web-scraper-order": "1666029434-2350",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😃 Grinning Face with Big Eyes",
    "people-href": "https://emojipedia.org/grinning-face-with-big-eyes/",
    emojiName: "😃 Grinning Face with Big Eyes",
    description:
      "A yellow face with smiling eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general happiness and good-natured amusement.",
    emoji: "😃",
  },
  {
    "web-scraper-order": "1666029444-2351",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😀 Grinning Face",
    "people-href": "https://emojipedia.org/grinning-face/",
    emojiName: "😀 Grinning Face",
    description:
      "A yellow face with simple, open eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general pleasure and good cheer or humor.",
    emoji: "😀",
  },
];

export default people;
